(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-program-2"] && !window.DesignMode) return;
  try {
    
(function($){ 
//console.log('affiliatepage');
$(document).ready(function(){
$(document).on("click", ".simpleAccordian .simpleAccordian__toggle", (function () {
        $(this).parent().siblings().removeClass("active"),
        $(this).parent().siblings().find(".simpleAccordian__cntnt").slideUp(),
        $(this).parent().toggleClass("active"),
        $(this).next(".simpleAccordian__cntnt").slideToggle(200)
        })
    );
});
})(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anniversary_header"]) return;
  try {
    
(function($){ 
$(document).ready(function(){
 let scrollheight
            if(window.matchMedia('(max-width: 750px)').matches) {
                scrollheight = 120
            }else{
                scrollheight = 100
                
            }
            
            let navhldr = $('.headerSection');
            let windowtop = scrollheight;
          
            
            // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
            function navbarCheck() {
                if ($(window).scrollTop() >= windowtop) {
                      let navhldrHeight = navhldr.innerHeight()
                    navhldr.addClass('sticky');
                    $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                    $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                } else {
                    navhldr.removeClass('sticky');
                    $(".headerFixed__wrap").css("height" ,"auto")
                    $(".recommendedFilter__Row").css("top" ,"auto")
                }
            }
            
            // navbarCheck()
            $(window).scroll(function () {
                navbarCheck()
            });  

            // navbarCheck()
            $(window).ready(function () {
                navbarCheck()
                //console.log("Hello World!");
            });   
            
            

            var new_scroll_position = 0;
            var last_scroll_position;
            var header = document.getElementById("header");

            window.addEventListener('scroll', function(e) {
                last_scroll_position = window.scrollY;

                if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                    header.classList.remove("slideDown");
                    header.classList.add("slideUp");
                    $("body").addClass("slideDownBody");
                    

                // Scrolling up
                } else if (new_scroll_position > last_scroll_position) {
                    header.classList.remove("slideUp");
                    header.classList.add("slideDown");
                    $("body").removeClass("slideDownBody");
                }

                new_scroll_position = last_scroll_position;
            });

  });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anti-cellulite-grid"] && !window.DesignMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
console.log('acai');
var cip = $(".beauty__routine__video").hover( hoverVideo, hideVideo );

function hoverVideo(e) {  
    $('video', this).get(0).play(); 
}

function hideVideo(e) {
    $('video', this).get(0).pause(); 
}
  });


      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anti-cellulite-testimonials"] && !window.DesignMode) return;
  try {
    
 (function($){ 
$(document).ready(function(){ 
  console.log('antii');
$(".twoRow__Review").each(function () {
        var divs = $(this).find('.twoRow__customerReview');
        for (var i = 0; i < divs.length; i += 2) {
            divs.slice(i, i + 2).wrapAll("<div class='column-12'></div>");

    }
});
  
 $(".twoRow__Review").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
});
});
 })(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barbieFeaturedImages"] && !window.DesignMode) return;
  try {
    
(function($){ 
  function run_animate() {
        var animation_items = $(".animate");

        var ml3 = 0;
        setInterval(function() {
            if (ml3 <= 0 - $(".barbie__animate .barbie__animateWrap").width() / 2) {
            ml3 = 0;
            }
        $(".barbie__animate .barbie__animateWrap").css("margin-left", ml3);
            ml3 -= 1;
        }, 10);
        }
     run_animate();   
       
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barbieFeaturedLogo"] && !window.DesignMode) return;
  try {
      
(function($){ 
 $(document).ready(function(){
   console.log('logos');
 $(".barbie__FeaturedInWrap_slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
   autoplaySpeed: 2000,  
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: true,
    responsive: [
        { breakpoint: 989, lazyLoad: 'progressive', settings: "unslick", },
    ],
});
 });
    })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barbieIndividualProducts"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
   //console.log('barbie');
   $(".barbie__ultimateSlider").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            responsive: [{
                breakpoint: 990,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 751,
                settings: { slidesToShow: 1, arrows: true, dots: false, centerMode: false, centerPadding: '0px', }
            }]
        });
   });
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-gift-of-year"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){ 
  console.log("vihps");
  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
        $(".sticky-wrap").addClass('sticky-show')
    } else {
        $(".sticky-wrap").removeClass('sticky-show')
    }
});

  // Smooth scroll when clicking on links with class 'cm_content_entry p a'
  $(document).on('click', '.cm_content_entry p a', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      // Calculate offset from the top of the section
      var offset = $(hash).offset().top;

      // Smoothly scroll to the section
      $('html, body').animate({
        scrollTop: offset
      }, 800); // Adjust the duration as needed (in milliseconds)
    }
  });


$(".m_videoSlider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    swipeToSlide: true,
    infinite: true,
    centerMode: true,
    centerPadding: "0",
    mobileFirst: true,
    responsive: [
        { breakpoint: 575, lazyLoad: 'progressive', settings: "unslick", },
        // { breakpoint: 751, settings: { slidesToShow: 2, slidesToScroll: 1, } },
        // { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1, } },
    ],
});

$('.m_videoSlider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('video').each(function () {
        this.pause(); // Stop playing
        $(".playpauseBtn").removeClass("active");
    });
}); 


  });
  })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["better-hair-removal-last-section"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
      $(window).on('scroll', function () {
            if ($(window).scrollTop() >= $('.shaveRoutine').offset().top ) {
              $(".sticky-wrap").addClass('sticky-show'),
              $(".head-order-btn").addClass('sticky-hide-head')
                if ($(window).scrollTop() >= $('.dontTakeOurWord').offset().top ) {
              $(".sticky-wrap").removeClass ('sticky-show')
              } else {
              $(".sticky-wrap").addClass('sticky-show')
              } 
            } else {
              $(".sticky-wrap").removeClass('sticky-show'),
              $(".head-order-btn").removeClass('sticky-hide-head')
            }
        
          });
         });
  
 
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["body-butter-product-sec"] && !window.DesignMode) return;
  try {
    
 (function($){
$(document).ready(function(){
  //console.log('d');
$(".productRelatedRow").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
        { breakpoint: 1251, settings: { slidesToShow: 7 } },
        { breakpoint: 1101, settings: { slidesToShow: 6 } },
        { breakpoint: 990, settings: { slidesToShow: 8 } },
        { breakpoint: 576, settings: { slidesToShow: 6 } },
        { breakpoint: 481, settings: { slidesToShow: 5 } },
        { breakpoint: 360, settings: { slidesToShow: 4 } },
    ],
});
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bogo"] && !window.DesignMode) return;
  try {
    
 (function($){
      $(document).ready(function () {
             console.log('bogopage');
var vipDealSlider = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    dots: false,
     infinite: false,
    responsive: [
        // { breakpoint: 1100, settings: { slidesToShow: 3 } },
        { breakpoint: 751, settings: { slidesToShow: 2 } },
        { breakpoint: 340, settings: { slidesToShow: 1 } },
        ],
    }

  $(".deal-Slider").slick(vipDealSlider);
        
          var vipMainSlider = {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
              adaptiveHeight: true,
              dots: false,
               infinite: false,
              responsive: [
                  { breakpoint: 1100, settings: { slidesToShow: 3 } },
                  { breakpoint: 751, settings: { slidesToShow: 2 } },
                  { breakpoint: 500, settings: { slidesToShow: 2 } },
                  ],
              }

              $(".InnerTabSlider").slick(vipMainSlider);
              $(document).ready(function () {
                  $('.unslickTabSlider li').click(function () {
                      var tab_id = $(this).attr('data-tab');
                      //alert(tab_id);
                      $("#" + tab_id).find('.InnerTabSlider').slick("unslick");
                      $("#" + tab_id).find('.InnerTabSlider').slick(vipMainSlider);
                  });
              });


              $(document).on("click", ".banner-accordian__toggle", (function () {
                  $(this).parent().siblings().removeClass("active"),
                      $(this).parent().siblings().find(".banner-accordian__cntnt").slideUp(1000),
                      $(this).parent().toggleClass("active"),
                      $(this).next(".banner-accordian__cntnt").slideToggle(500)

                      $(this).parent().find(".InnerTabSlider, .deal-Slider").slick("unslick");
                      $(this).parent().find(".InnerTabSlider").slick(vipMainSlider);
                      $(this).parent().find(".deal-Slider").slick(vipDealSlider);
              })
              );

       });
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand_logo"] && !window.DesignMode) return;
  try {
      
(function($){ 
 $(document).ready(function(){
   
 $(".logo--carousel").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: true,
    responsive: [
        { breakpoint: 989, lazyLoad: 'progressive', settings: "unslick", },
    ],
});
 });
    })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundleSliderAcai"] && !window.DesignMode) return;
  try {
    
(function($){  
console.log('slider') ; 
$(document).ready(function(){
function bundleTable__slider() {
        $(".bundleTable__slider").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: $(".bundleTableSection__prevBtn"),
            nextArrow: $(".bundleTableSection__nextBtn"),
            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 3 } },
                { breakpoint: 990, settings: { slidesToShow: 2, adaptiveHeight: true} },
                { breakpoint: 700, settings: { slidesToShow: 1 } },
            ],
        });
    }

    function setEqualHeight() {
        
        for (let i = 1; i < 10; i++) {
            var $sameHeightDivs = $(`.bundleTable__col--${i}`);
            var maxHeight = 0;
            $sameHeightDivs.each(function () {
                maxHeight = Math.max(maxHeight, $(this).outerHeight());
            });
            $sameHeightDivs.css({ height: maxHeight + 'px' });
        }
    }

    $(document).ready(function () {
        bundleTable__slider()
        setEqualHeight();
    });

    $(window).on('resize', function () {
        bundleTable__slider()
        setEqualHeight();
    }); 
 });
})(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clientListSlider"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
   
$('.clintListSlider').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        } 
    ]

});


         });
  
 
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-420"] && !window.DesignMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
  // $(".newarrival").slick({
  //           slidesToShow: 4,
  //           slidesToScroll: 1,
  //           arrows: true,
  //           adaptiveHeight: !1,
  //           dots: false,
  //           fade: false,
  //           infinite: false,
  //           prevArrow: $(".favPrev__btn_nw"),
  //           nextArrow: $(".favNext__btn_nw"),
  //           responsive: [{
  //               breakpoint: 990,
  //               settings: { slidesToShow: 3 }
  //           }, {
  //               breakpoint: 751,
  //               settings: { slidesToShow: 2 }
  //           },]
  //       });
      // $(".shopbestseller").slick({
      //       slidesToShow: 4,
      //       slidesToScroll: 1,
      //       arrows: true,
      //       adaptiveHeight: !1,
      //       dots: false,
      //       fade: false,
      //       infinite: false,
      //       prevArrow: $(".favPrev__btn_nws"),
      //       nextArrow: $(".favNext__btn_nws"),
      //       responsive: [{
      //           breakpoint: 990,
      //           settings: { slidesToShow: 3 }
      //       }, {
      //           breakpoint: 751,
      //           settings: { slidesToShow: 2 }
      //       },]
      //   });
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-box"] && !window.DesignMode) return;
  try {
    
(function($){
  $(document).ready(function () {
 colnsole.log('yyr');
  });
})(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-top-area"] && !window.DesignMode) return;
  try {
    
 (function($){
     $(document).ready(function(){
      const smallUsps = Array.from(document.querySelectorAll('.all-usp-sm .single-usp'));
        let showElmIndex = 0;
        //console.log(smallUsps);
        setInterval(() => {
            smallUsps.map((item, index) => {
                if (index === showElmIndex) {
                    item.style.display = 'flex';
                } else {
                    item.style.display = 'none';
                }
            })
            showElmIndex === smallUsps.length - 1 ? showElmIndex = 0 : showElmIndex++;
        }, 2500)
        });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactForm"] && !window.DesignMode) return;
  try {
    
 (function($){
      $(document).ready(function () {
      //console.log('contact');
        $('.tooltipToggle').click(function () {
          $(this).addClass('active-tooltip');
          $(this).parents('.tooltipOuter').find('.tooltip-Info').toggle();
        });
        $('#contacttopics').on('change', function() {
          var optionchossed = this.value.toLowerCase().replace(/\s/g, '_');
             if(optionchossed!='' && optionchossed != 'influencer'){
            //console.log(optionchossed);
            $('.step-tooltip').addClass('hide');
            $('.'+optionchossed).removeClass('hide');
            $('.contactmessage').removeClass('hide');
            $('.order_number').removeClass('hide');
            $('#submitticket').removeClass('hide');
         }else if(optionchossed === 'influencer'){
           window.location.href = "https://www.trulybeauty.com/pages/influencer";
            $('.order_status').addClass('hide');
            $('.order_number').addClass('hide');
            $('.contactmessage').addClass('hide');
            $('#submitticket').addClass('hide');
          }else{
            $('.order_status').addClass('hide');

            $('.order_number').addClass('hide');
            $('.contactmessage').addClass('hide');
            $('#submitticket').addClass('hide');
          }
        });
        if(document.getElementById("customeremail").value.length != 0){
          var customeremail = $("#customeremail").val();
          if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($("#customeremail").val())) {
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/gorgias/getcustomer.php",
              type: 'POST',
              data: {"customeremail":customeremail},
              async: true,
              success: function (data) {
                $('.order_number_field').html(data);

              },
              timeout: 5000000, // sets timeout to 5 seconds
              // contentType: false,
              //  processData: false
            });

          }
        }
        $("#customeremail").blur(function(){
          var customeremail = $("#customeremail").val();
          if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($("#customeremail").val())) {
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/gorgias/getcustomer.php",
              type: 'POST',
              data: {"customeremail":customeremail},
              async: true,
              success: function (data) {
                $('.order_number_field').html(data);

              },
              timeout: 5000000, // sets timeout to 5 seconds
              // contentType: false,
              //  processData: false
            });

          }

        });
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#contactUs-Form").submit(function(){
          required = ["contactcomment"];
          srequired = ["contacttopics"];
          email = $("#customeremail");
          for (i=0;i<required.length;i++) {
            var textarea = $('#'+required[i]);
            if ((textarea.val() == "") || (textarea.val() == emptyerror)) {
              textarea.addClass("needsfilled");
              textarea.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              textarea.removeClass("needsfilled");
            }
          }
          for (i=0;i<srequired.length;i++) {
            var selectinput = $('#'+srequired[i]);
            if (selectinput.val() == "") {
              selectinput.addClass("needsfilled");
            } else {
              selectinput.removeClass("needsfilled");
            }
          }
          //var newpassword = $('#password').val();
          //var conformpassword = $('#confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}


          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if ($("#other_guidelines").hasClass("needsfilled")) {
            return false;
          }else if ($("#contacttopics").hasClass("needsfilled")) {
            return false;
          } else {

            var $form = $('#contactUs-Form');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#submitticket').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#submitticket').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/gorgias/creategticket.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#submitticket').prop('disabled', false);
                $('#contactUs-Form')[0].reset();
                if (data.indexOf('Request Submitted Sucessfully.') > -1) {
                  $('.contact-response').html(data).css("color","#509d24");
                  setTimeout(function () { location.reload(true);}, 3000);

                }else{
                  $('.contact-response').html(data).css("color","#ff0000");
                  setTimeout(function () { location.reload(true);}, 3000);
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });

        $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});



        
      });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-edit-profile"]) return;
  try {
    
  (function($){
      $(document).ready(function(){
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#customer_edit_profile").submit(function(){
          required = ["customer_first_name","customer_last_name"];
          email = $("#customer_email");
          for (i=0;i<required.length;i++) {
            var input = $('#'+required[i]);
            if ((input.val() == "") || (input.val() == emptyerror)) {
              input.addClass("needsfilled");
              input.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              input.removeClass("needsfilled");
            }
          }
          var newpassword = $('#customer_password').val();
          var conformpassword = $('#customer_confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if(newpassword!='' && newpassword.length <8){newpassword.addClass("needsfilled");newpassword.val('should contain 8 characters').attr('type', 'text');}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if(newpassword!=conformpassword){
            $('#customer_password').addClass("needsfilled");
            $("#customer_confirm_password").val("Confirm Password not match with password");
            $('#customer_confirm_password').addClass("needsfilled");
            return false;

          }else {

            var $form = $('#customer_edit_profile');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#update_profile').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#update_profile').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/index.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#update_profile').prop('disabled', false);

                if(data=='Sucess'){
                  alert('Profile Update Sucessfully.');
                }else{
                  alert(data);
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
        $("#customer_phone, #AddressPhoneNew, input[name='address[phone]']").bind("keypress", function (event) {
          var keyCode = event.which ? event.which : event.keyCode

          if ((keyCode == 43)) {
            return true;
          }else if (!(keyCode >= 48 && keyCode <= 57 )){
            return false;
          }

          var minLength = 12;
          var phone = $(this).val();
          if (phone.length > minLength){
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");$("#customer_password").attr('type', 'password');}});
    })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doubleSlider"] && !window.DesignMode) return;
  try {
    
(function($){  
console.log('double');
$(document).ready(function(){
  $('.trulySlidemain').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        asNavFor: '.trulySlideNav'
    });
                                
    $('.trulySlideNav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: '.trulySlidemain',
        arrows: true,
        prevArrow: $(".trulySlideNav__btn.trulySlideNav__btnLeft"),
        nextArrow: $(".trulySlideNav__btn.trulySlideNav__btnRight"),
    });


 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doubleSliderleftSec"] && !window.DesignMode) return;
  try {
    
(function($){  
console.log('double2');
$(document).ready(function(){

    $('.trulySlidemain-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        asNavFor: '.trulySlideNav-3'
    });
                                
    $('.trulySlideNav-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: '.trulySlidemain-3',
        arrows: true,
        prevArrow: $(".trulySlideNav-3__btn.trulySlideNav__btnLeft"),
        nextArrow: $(".trulySlideNav-3__btn.trulySlideNav__btnRight"),
    }); 

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doubleSliderRightMedia"] && !window.DesignMode) return;
  try {
    
(function($){  
  console.log('right')
$(document).ready(function(){
    $('.trulySlidemain-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        asNavFor: '.trulySlideNav-2'
    });
                                
    $('.trulySlideNav-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: '.trulySlidemain-2',
        arrows: true,
        prevArrow: $(".trulySlideNav-2__btn.trulySlideNav__btnLeft"),
        nextArrow: $(".trulySlideNav-2__btn.trulySlideNav__btnRight"),
    });

   

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["earlyaccess"] && !window.DesignMode) return;
  try {
    
(function($){
      $(document).ready(function(){
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#kiayvio_request").submit(function(){
          required = ["phone_number","name"];
          email = $("#email");
          for (i=0;i<required.length;i++) {
            var input = $('#'+required[i]);
            if ((input.val() == "") || (input.val() == emptyerror)) {
              input.addClass("needsfilled");
              input.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              input.removeClass("needsfilled");
            }
          }
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if ($('#special_offer').is(':checked')){$('#special_offer_label').css("color","#000");}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if (! $('#special_offer')[0].checked){
            $('#special_offer_label').css("color","#ff0000");
            return false;
          } else {
            var $form = $('#kiayvio_request');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#submit_detail').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#submit_detail').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/earlyacess-form.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#submit_detail').prop('disabled', false);
                $('form#kiayvio_request').get(0).reset()	;
                if (data.indexOf('success') > -1) {
                  $('.infulencer-response').html('<p>Thanks for subscribe.</p>').css("color","#509d24");
                  $('.infulencer-response p').css("color","#509d24");
                }else{
                  $('.infulencer-response').html('<p>'+data+'</p>').css("color","#ff0000");
                  $('.infulencer-response p').css("color","#ff0000");
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fix-my-red-bumpy-skin"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 
  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
        $(".sticky-wrap").addClass('sticky-show')
    } else {
        $(".sticky-wrap").removeClass('sticky-show')
    }
});
  });
  })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flip-product-simple"] && !window.DesignMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
console.log('hhh');
 
  });
  })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flip-product"] && !window.DesignMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
console.log('sssss');
 
  });
  })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-specialoffer"]) return;
  try {
    
  (function($){ 
$(document).ready(function(){
  $(".smoothScroll").on('click', function(event) {
        
      if (this.hash !== "") {
        event.preventDefault();
        // Store hash
        var hash = this.hash;
        $('html, body').animate({ scrollTop: $(hash).offset().top}, 800, function(){ window.location.hash = hash;});
      } // End if
    }); 
if ($(".stickyWrapShow").length > 0) {
    // sticky bar
    $(window).on('scroll', function () {
        if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top) {
            $(".sticky-wrap").addClass('sticky-show')
            $(".head-order-btn").addClass('sticky-hide-head')
        } else {
            $(".sticky-wrap").removeClass('sticky-show')
            $(".head-order-btn").removeClass('sticky-hide-head')
        }
    });
}  
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullLengthTestimonial"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 $(".fullWide_testimonial").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1, } },
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }

    ]
});
 });
})(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_faq"] && !window.DesignMode) return;
  try {
    
      (function ($) {
      $(document).ready(function () {
     	$(".accordion").click(function() {
    	var questionDiv = $(this);
    	var answerDiv   = $(this).next('.acdn_content');
    	var idx = $('.acdn_content').index(answerDiv);

    	$('.acdn_content').each(function(index, ansDiv) {
               if(index != idx && $(ansDiv).is(':visible')) {
    			$(ansDiv).slideUp(500, function() {
    				$(ansDiv).prev('.accordion').removeClass('accordion_open');
    			});
    		}
           });

    	if (answerDiv.is(':visible')) {
    		answerDiv.stop().slideUp(500, function() {
    			questionDiv.removeClass('accordion_open');
    		});
    	} else {
    	  questionDiv.addClass('accordion_open');
    	  answerDiv.stop().slideDown(500);
    	}
    });
        });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_order_save_strip"] && !window.DesignMode) return;
  try {
    
   	var spd = 100;
  var spdVal = 10;
  var cntDown = 5 * 60 * spdVal;
  setInterval(function () {
  	var mn, sc, ms;
  	cntDown--;
  	if(cntDown < 0) {
  		return false;
  	}
  	mn = Math.floor((cntDown / spdVal) / 60 );
  	mn = (mn < 5 ? '0' + mn : mn);
  	sc = Math.floor((cntDown / spdVal) % 60);
  	sc = (sc < 5 ? '0' + sc : sc);
  	ms = Math.floor(cntDown % spdVal);
  	ms = (ms < 5 ? '0' + ms : ms);
  	var result = mn + ':' + sc;
  	document.getElementById('stopwatch').innerHTML = result;
  }, spd);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["GDSS_Product_Section"] && !window.DesignMode) return;
  try {
    
            (function ($) {
                        $(document).ready(function(){
                          	$('.slide-div').slick({
                       	slidesToShow: 1,
                       	slidesToScroll: 1,
                       	arrows: false,
                       	fade: false,
                       	asNavFor: '.slider-nav',
                       	autoplay: false,
                       	autoplaySpeed: 11000,
                       	dots: false,
                       });

                       $('.slider-nav').slick({
                       	slidesToShow:5,
                       	slidesToScroll: 1,
                       	asNavFor: '.slide-div',
                       	dots: false,
                       	centerMode: false,
                       	focusOnSelect: true,
                       	arrows: false,
                       });


                        $('.purchase_opt').click(function(e) {
                      	$('.purchase_opt').removeClass('active');
                      	$(this).addClass('active');
                      });

                      // $('.purchase_opt').click(function(e) {
                      // 	if (!$(this).find(".pck-bx-rad").attr("checked")) {
                      // 		$(this).parent('.selectBox').find(".pck-bx-rad").removeAttr("checked");
                      // 		$(this).find(".pck-bx-rad").attr("checked", "checked");
                      // 	}
                      // });
  var container = $('.sNine_right');
  var onetime = container.find('#buying_onetime_id');
  var subscription = container.find('#buy_subscription_id');
  var btn = container.find('.packgeBtn');
  var sellingPlan = container.find('.selling_plan');

  $('.purchase_opt').click(function(e) {
    if (!$(this).find(".pck-bx-rad").prop("checked")) {
      $(this).closest('.selectBox').find(".pck-bx-rad").prop("checked", false);
      $(this).find(".pck-bx-rad").prop("checked", true);
      updateButton();
    }
  });

  function updateButton() {
    if (subscription.prop('checked')) {
      btn.text('Subscribe Now');
      sellingPlan.attr('name', 'selling_plan');
      onetime.removeAttr('name');
    } else if (onetime.prop('checked')) {
      btn.text('Add to Bag');
      sellingPlan.removeAttr('name');
      onetime.removeAttr('name');
    }
  }

  updateButton();

  subscription.on('change', updateButton);
  onetime.on('change', updateButton);




                        });
  $(document).ready(function() {
    $('.subscribe-checkbox').each(function() {
      togglePrice($(this));
      toggleButtonText($(this));
    });

    $('.subscribe-checkbox').change(function() {
      togglePrice($(this));
      toggleButtonText($(this));
    });

    function togglePrice(checkbox) {
      var packageContainer = checkbox.closest('.package');
      var onetimePrice = packageContainer.find('.onetimeprice');
      var subscriptionPrice = packageContainer.find('.subscriptionprice');
      var onetimeSaving = packageContainer.find('.onetimesaving');
      var subscriptionSaving = packageContainer.find('.subscriptionsaving');
      var subscriptionRegPrice = packageContainer.find('.subscriptionreg_price');
      var onetimeRegPrice = packageContainer.find('.onetimereg_price');
      var sellingPlanSelect = packageContainer.find('.selling_plan');
      var productPrice = packageContainer.find('.productPrice');
      var regularPrice = packageContainer.find('.regular_price');
      var comparePrice = regularPrice.data('compare-price');

      if (checkbox.is(':checked')) {
        onetimePrice.hide();
        onetimeSaving.hide();
        subscriptionPrice.show();
        subscriptionSaving.show();
        subscriptionRegPrice.show();
        onetimeRegPrice.hide();
        sellingPlanSelect.attr('name', 'selling_plan');
        productPrice.show();
        if (comparePrice === 0) {
        regularPrice.removeClass('hidden');
      } else {
        regularPrice.removeClass('hidden');
      }
      } else {
        onetimePrice.show();
        onetimeSaving.show();
        subscriptionPrice.hide();
        subscriptionSaving.hide();
        subscriptionRegPrice.hide();
        onetimeRegPrice.show();
        sellingPlanSelect.removeAttr('name');
        productPrice.hide();
        if (comparePrice === 0) {
        regularPrice.addClass('hidden');
      } else {
        regularPrice.removeClass('hidden');
      }
      }

     /* if (checkbox.is(':checked')) {
    onetimePrice.css('visibility', 'hidden');
    onetimeSaving.css('visibility', 'hidden');
    subscriptionPrice.css('visibility', 'visible');
    subscriptionSaving.css('visibility', 'visible');
    subscriptionRegPrice.css('visibility', 'visible');
    onetimeRegPrice.css('visibility', 'hidden');
    sellingPlanSelect.attr('name', 'selling_plan');
  } else {
    onetimePrice.css('visibility', 'visible');
    onetimeSaving.css('visibility', 'visible');
    subscriptionPrice.css('visibility', 'hidden');
    subscriptionSaving.css('visibility', 'hidden');
    subscriptionRegPrice.css('visibility', 'hidden');
    onetimeRegPrice.css('visibility', 'visible');
    sellingPlanSelect.removeAttr('name');
  }*/
    }

    function toggleButtonText(checkbox) {
      var targetBtn = checkbox.data('target-btn');
      var button = $('.packgeBtn[data-target-btn="' + targetBtn + '"]');

      if (checkbox.is(':checked')) {
        button.text('Subscribe Now');
      } else {
        button.text('Add to Bag');
      }
    }
  });



              })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_results"] && !window.DesignMode) return;
  try {
    
   	function getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
  	'total': t,
  	'days': days,
  	'hours': hours,
  	'minutes': minutes,
  	'seconds': seconds
    };
  }

  /*OFFER_TIMER*/
  function initializeClock(id, endtime) {
    var clock = document.getElementById(id);
   // var daysSpan = clock.querySelector('.days');
    var hoursSpan = clock.querySelector('.hours');
    var minutesSpan = clock.querySelector('.minutes');
    var secondsSpan = clock.querySelector('.seconds');
    function updateClock() {
  	var t = getTimeRemaining(endtime);
     // daysSpan.innerHTML = t.days;
  	hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
  	minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
  	secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
  	if (t.total <= 0) {
  	  clearInterval(timeinterval);
  	}
    }
    updateClock();
    var timeinterval = setInterval(updateClock, 1000);
  }
  var deadline = new Date(Date.parse(new Date()) + 60 * 120 * 1000);
  initializeClock('clockdiv3', deadline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_review_section"] && !window.DesignMode) return;
  try {
    
    (function ($) {
      $(document).ready(function () {
          $('.section_one_slider').slick({
  		dots: false,
  		slidesToShow: 3,
  		slidesToScroll: 1,
  		arrows: false,
  		responsive: [

  		{
  			breakpoint: 9999,
  			settings: "unslick"
  		},
  		{
  			breakpoint: 767,
  			settings: {
  				dots: false,
  				slidesToShow:1,
  				arrows: true,
  				adaptiveHeight: false,
  			}
  		},
  		]
  	});
      });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_social_media"] && !window.DesignMode) return;
  try {
    
  (function ($) {
    $(document).ready(function () {
      $('ul.top_social_list').slick({
        autoplay: true,
        arrows: false,
        dots: false,
        variableWidth: false,
        centerMode: false,
        autoplaySpeed: 0,
        speed: 4000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 9999,
            settings:"unslick"
          }
        ]
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_sticky_button"] && !window.DesignMode) return;
  try {
    
   (function($){
    $(document).ready(function(){
      $(document).scroll(function() {
        if ($(window).width() <= 768) {
          $('.gdss_sticky_btn').addClass('gdss_sticky_show');
        }else{
          $('.gdss_sticky_btn').removeClass('gdss_sticky_show');
        }
      });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdss_whatsincluded"] && !window.DesignMode) return;
  try {
    
  (function($){
    $(document).ready(function(){
   	$('.sThree_kitSlider').slick({
  	dots: true,
  	slidesToShow: 3,
  	slidesToScroll: 1,
  	arrows: true,
  	responsive: [
  	{
  		breakpoint: 1200,
  		settings: {
  			slidesToShow:2,
  		}
  	},
  	{
  		breakpoint: 767,
  		settings: {
  			dots: true,
  			slidesToShow:1.2,
  			slidesToShow:1,
  			variableWidth: true,
  			centerMode: false,
  		}
  	},
  	]
  });
      });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-sets"] && !window.DesignMode) return;
  try {
    
  (function($){
      $(document).ready(function () {
console.log('gift-sets');
   if ($(window).width() <= 989) {

          function replaceContent(x, z){
          // save the inner html of the first node in temp
          let temp = document.getElementById(x).innerHTML;
          // move the innerHtml of the second node into first node
          document.getElementById(x).innerHTML = document.getElementById(z).innerHTML;
          // replace the second node's inner html with temp (saved previously)
          document.getElementById(z).innerHTML = temp;
          }

          // replace the divs of id 2 and 4
          replaceContent("1", "5");
          replaceContent("2", "6");
          replaceContent("3", "7");
          replaceContent("4", "8");
          // replaceContent("gift-products-9", "gift-products-10");

      }

          // Only One video At a time
        $('.trulyTab li').click(function () {
          var tab_id = $(this).attr('data-tab');
           // for video paly on tabs

          $("#" + tab_id).find('video').get(0).play()
          $("#" + tab_id).siblings().find('video').get(0).pause()
          $("#" + tab_id).find('.TabVideo').find('.playpauseBtn').addClass('active')


      });
          // Only One video At a time
    function videoPlay() {
          $(".trulyTab__cntnt.current").find('video').get(0).play()
      }
      videoPlay()
   });
     
    })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift_box"] && !window.DesignMode) return;
  try {
    

  (function($){

  $(document).ready(function(){
      console.log("eees");
    $(window).on('scroll', function () {
      if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
        $(".sticky-wrap").addClass('sticky-show')
        //$(".head-order-btn").addClass('sticky-hide-head')
      } else {
        $(".sticky-wrap").removeClass('sticky-show')
       // $(".head-order-btn").removeClass('sticky-hide-head')
      }
  });


  });
        })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-glazed_donut_shave_set_v1"] && !window.DesignMode) return;
  try {
    
   (function ($) {
     $(document).scroll(function() {
   	if ($(this).scrollTop() > 110){
   		$('.top-fix-bar').addClass('fixed-nav');
   	}else{
   		$('.top-fix-bar').removeClass('fixed-nav');
   	}
   });
   	$(".btn_scorall").click(function() {
  	$('html, body').animate({
  		scrollTop: $("#select_pkg").offset().top - 50
  	}, 2000);
  });
  // var scroll = new SmoothScroll('a[href*="#"]', {
  // 	speed: 500,
  // });
   })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function($){
  $(document).ready(function(){
    console.log('notslideupdown');
   let scrollheight
              if(window.matchMedia('(max-width: 750px)').matches) {
                  scrollheight = 120
              }else{
                  scrollheight = 100

              }

              let navhldr = $('.headerSection');
              let windowtop = scrollheight;


              // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
              function navbarCheck() {
                  if ($(window).scrollTop() >= windowtop) {
                        let navhldrHeight = navhldr.innerHeight()
                      navhldr.addClass('sticky');
                      $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                      $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                    $("#template-shave-starter-pack .sticky_sec").css("top", (navhldrHeight - 1) + "px")
                    $("#template-shave-starter-pack-1 .sticky_sec").css("top", (navhldrHeight - 1) + "px")
                  } else {
                      navhldr.removeClass('sticky');
                      $(".headerFixed__wrap").css("height" ,"auto")
                      $(".recommendedFilter__Row").css("top" ,"auto")
                    $("#template-shave-starter-pack .sticky_sec").css("top", "auto")
                    $("#template-shave-starter-pack-1 .sticky_sec").css("top", "auto")
                  }
              }

              // navbarCheck()
              $(window).scroll(function () {
                  navbarCheck()
              });

              // navbarCheck()
              $(window).ready(function () {
                  navbarCheck()
                  //console.log("Hello World!");
              });



              var new_scroll_position = 0;
              var last_scroll_position;
              var header = document.getElementById("header");

              window.addEventListener('scroll', function(e) {
                  last_scroll_position = window.scrollY;

                  if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                     header.classList.remove("slideDown");
                     header.classList.add("slideDown"); //header.classList.add("slideUp");
                     $("body").addClass("slideDownBody");


                  // Scrolling up
                  } else if (new_scroll_position > last_scroll_position) {
                      header.classList.remove("slideUp");
                      header.classList.add("slideUp"); //header.classList.add("slideDown");
                      $("body").removeClass("slideDownBody");
                  }

                  new_scroll_position = last_scroll_position;
              });

    });
        })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_glazed_donut"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
  //console.log('header');
 let scrollheight
            if(window.matchMedia('(max-width: 750px)').matches) {
                scrollheight = 120
            }else{
                scrollheight = 100
                
            }
            
            let navhldr = $('.headerSection');
            let windowtop = scrollheight;
          
            
            // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
            function navbarCheck() {
                if ($(window).scrollTop() >= windowtop) {
                      let navhldrHeight = navhldr.innerHeight()
                    navhldr.addClass('sticky');
                    $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                    $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                } else {
                    navhldr.removeClass('sticky');
                    $(".headerFixed__wrap").css("height" ,"auto")
                    $(".recommendedFilter__Row").css("top" ,"auto")
                }
            }
            
            // navbarCheck()
            $(window).scroll(function () {
                navbarCheck()
            });  

            // navbarCheck()
            $(window).ready(function () {
                navbarCheck()
                //console.log("Hello World!");
            });   
            
            

            var new_scroll_position = 0;
            var last_scroll_position;
            var header = document.getElementById("header");

            window.addEventListener('scroll', function(e) {
                last_scroll_position = window.scrollY;

                if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                    header.classList.remove("slideDown");
                    header.classList.add("slideUp");
                    $("body").addClass("slideDownBody");
                    

                // Scrolling up
                } else if (new_scroll_position > last_scroll_position) {
                    header.classList.remove("slideUp");
                    header.classList.add("slideDown");
                    $("body").removeClass("slideDownBody");
                }

                new_scroll_position = last_scroll_position;
            });

  });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_mini_offers_landing"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 let scrollheight
            if(window.matchMedia('(max-width: 750px)').matches) {
                scrollheight = 120
            }else{
                scrollheight = 100
                
            }
            
            let navhldr = $('.headerSection');
            let windowtop = scrollheight;
          
            
            // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
            function navbarCheck() {
                if ($(window).scrollTop() >= windowtop) {
                      let navhldrHeight = navhldr.innerHeight()
                    navhldr.addClass('sticky');
                    $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                    $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                } else {
                    navhldr.removeClass('sticky');
                    $(".headerFixed__wrap").css("height" ,"auto")
                    $(".recommendedFilter__Row").css("top" ,"auto")
                }
            }
            
            // navbarCheck()
            $(window).scroll(function () {
                navbarCheck()
            });  

            // navbarCheck()
            $(window).ready(function () {
                navbarCheck()
                //console.log("Hello World!");
            });   
            
            

            var new_scroll_position = 0;
            var last_scroll_position;
            var header = document.getElementById("header");

            window.addEventListener('scroll', function(e) {
                last_scroll_position = window.scrollY;

                if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                    header.classList.remove("slideDown");
                    header.classList.add("slideUp");
                    $("body").addClass("slideDownBody");
                    

                // Scrolling up
                } else if (new_scroll_position > last_scroll_position) {
                    header.classList.remove("slideUp");
                    header.classList.add("slideDown");
                    $("body").removeClass("slideDownBody");
                }

                new_scroll_position = last_scroll_position;
            });

  });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bagBathSection"] && !window.DesignMode) return;
  try {
    
 (function($){
    //console.log('bagslider');
     $(document).ready(function(){
      $(".iconicbagSlider").slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 751,
                    settings: {
                        slidesToShow: 1.05,
                        slidesToScroll: 1,
                       useTransform: false,
                        // centerMode: true, 
                        // centerPadding: "60px",  
                        infinite: false,
                        dots: true,
                    }
                },
            ]
        });
        });
      })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeCollectionTabs"] && !window.DesignMode) return;
  try {
    
(function($){  
$(document).ready(function(){
  var slider_value= $('#slider').val();
  if(slider_value == 'true')
  {
   var url_grid = 'tabcolslider';
  }
  else{
   var url_grid = 'tabcol'
  }
  //console.log(slider_value);
 sellitems ='';
            $('.recommendedFilter__Row span').click(function(){
                   setTimeout(() => {
                    $('body, html').animate({ scrollTop: $(this).parents('.recommendedWrap').offset().top }, 600)
                }, 50)
              $('li span').removeClass("activeFilter");
                $(this).addClass("activeFilter");
             var data_show = $(this).parent().attr('data-show');   
                var selected_col = $(this).parent().attr('data-id');   
                    $.ajax({
                      url: "/collections/"+selected_col+"?view="+url_grid,
                      type: 'GET',
                      cache: false,
                       success: function (response) { 
                           sellitems  = response;  
                        //console.log(response);
                        },
                   timeout: 5000000,       
                      }).done(function() {
                      $('.recommendedData__Row').empty();
                         $('.recommendedData__Row').html(sellitems); 
                            var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
                            
                            if ("IntersectionObserver" in window) {
                            let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                            entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                            let lazyImage = entry.target;
                            lazyImage.src = lazyImage.dataset.src;
                            //  lazyImage.srcset = lazyImage.dataset.srcset;
                            lazyImage.classList.remove("lazy");
                            lazyImageObserver.unobserve(lazyImage);
                            }
                            });
                            });
                            
                            lazyImages.forEach(function(lazyImage) {
                            lazyImageObserver.observe(lazyImage);
                            });
                            } else {
                            // Possibly fall back to event handlers here
                            }
                         StampedFn.reloadUGC();  
                      })
                      .fail(function(data) {})
                      .always(function(data) {});
              });
 });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeRotationalBar"] && !window.DesignMode) return;
  try {
    
(function($){ 
//console.log('rotationalbar');
$(document).ready(function(){
const smallUsps = Array.from(document.querySelectorAll('.all-usp__Style .single-usp__Style'));
        let showElmIndex = 0;
        //console.log(smallUsps);
        setInterval(() => {
            smallUsps.map((item, index) => {
                if (index === showElmIndex) {
                    item.style.display = 'flex';
                    item.style.height = "initial" ;
                    item.style.width = "initial" ;
                    item.style.opacity = "1" ;

                } else {
                    // item.style.display = 'none';
                    item.style.height = "0" ;
                    item.style.width = "0" ;
                    item.style.opacity = "0" ;
                }
            })
            showElmIndex === smallUsps.length - 1 ? showElmIndex = 0 : showElmIndex++;
        }, 2500)

        });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-repeter"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function () {
    // Wait for all videos to be loaded and ready
  var videos = document.querySelectorAll('.mydVideos');
  
  videos.forEach(function (video) {
    video.addEventListener('canplay', function () {
      video.play();
    });
  });
});
  })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !window.DesignMode) return;
  try {
    
  (function($){
   $(document).ready(function(){
     console.log('sdsdfsdfsdsd');
   });
      })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencer"] && !window.DesignMode) return;
  try {
    
  (function($){
      $(document).ready(function(){
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#Influencer_request").submit(function(){
         required = ["first_name","last_name","password","confirm_password","custom_83641","custom_82327","custom_82326","custom_82324","custom_81275","conversion_trigger_coupon"];
          email = $("#email");
          payemail = $("#paypal_email_80624");
          for (i=0;i<required.length;i++) {
            var input = $('#'+required[i]);
            if ((input.val() == "") || (input.val() == emptyerror)) {
              input.addClass("needsfilled");
              input.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              input.removeClass("needsfilled");
            }
          }
          var newpassword = $('#password').val();
          var confirmpassword = $('#confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if  (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(payemail.val())) {payemail.addClass("needsfilled");payemail.val(emailerror);}

          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if(newpassword!=confirmpassword){
            $('#password').addClass("needsfilled");
            $('#confirm_password').addClass("needsfilled");
            return false;

          }
          else {

            var $form = $('#Influencer_request');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#Influencer_request').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#Influencer_request').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/refersion.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#Influencer_request').prop('disabled', false);

                if (data.indexOf('Thanks') > -1) {
                  $('.infulencer-response').html(data).css("color","#509d24");
                  $('.infulencer-response p').css("color","#509d24");
                  $('#Influencer_request')[0].reset();
                  $('.infulencer-response').delay(5000).fadeOut('slow');

                }else{
                  $('.infulencer-response').html(data).css("color","#ff0000");
                  $('.infulencer-response p').css("color","#ff0000");
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-targets"] && !window.DesignMode) return;
  try {
    
  (function($){
    $(document).ready(function () {
    $(".Single__ImgSlider").slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: false,
         dots: true,
         infinite: false,
      //    responsive: [
      //     {breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false, }},
      //     {breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false,   }}
      // ]
  });
    });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landingFreeSlider"] && !window.DesignMode) return;
  try {
    
(function($){ 
//console.log('onhalfSliderRights');
$(document).ready(function(){
$('.onhalfSliderRight').slick({
    slidesToShow: 1.5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow: $(".onhalfSliderRight__btn.onhalfSliderRight__btnLeft"),
    nextArrow: $(".onhalfSliderRight__btn.onhalfSliderRight__btnRight"),
});  

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landingpagemedia"] && !window.DesignMode) return;
  try {
    
 
(function($){   
$(document).ready(function(){  
$(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
      $(".sticky-wrap").addClass('sticky-show')
      //$(".head-order-btn").addClass('sticky-hide-head')
    } else {
      $(".sticky-wrap").removeClass('sticky-show')
     // $(".head-order-btn").removeClass('sticky-hide-head')
    }
});
  

});
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
(function ($) {
 $(document).ready(function () {
    //console.log('accountusesr');
   loadstampedreviews();
 $(".RecentlySilder").slick({
    slidesToShow: 4,
     slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: !1,
            dots: false,
            fade: false,
            infinite: false,
            prevArrow: $(".favPrev__btn_sl"),
            nextArrow: $(".favNext__btn_sl"),
    responsive: [
        { breakpoint: 1100, settings: { slidesToShow: 3 } },
        { breakpoint: 500, settings: { slidesToShow: 2 } },
    ]
}); 
Shopify.Products.showRecentlyViewed( { howManyToShow:10, onComplete: function() { 
 
        $(".Recentlyviewed").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: !1,
            dots: false,
            fade: false,
            infinite: false,
            prevArrow: $(".favPrev__btn"),
            nextArrow: $(".favNext__btn"),
            responsive: [
                { breakpoint: 1100, settings: { slidesToShow: 3 } },
                { breakpoint: 500, settings: { slidesToShow: 2 } },
            ]

        });
      }});
   
  
  });
      
}(jQuery));   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function($){

window.onload = () => {
    typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  };
  
$(document).ready(function () {
  console.log('address');
    $('.add-addressBtn').click(function () {
        $(this).toggleClass('active-filter');
        $(this).parents('.addNew__Address').find('.mainAddress__form').slideToggle();
    });


    $('.cancel-btn').click(function () {
        $(this).parents('.addNew__Address').find('.mainAddress__form').slideUp();
        $('.add-addressBtn').removeClass('active-filter');
    });

       //check add address required

$("form#address_form_new").submit(function(){
    //alert('dde');
       var minLength = 10;
       var value = $("#address_form_new input[name='address[phone]']").val(); 
      required = ["AddressFirstNameNew","AddressLastNameNew","AddressAddress1New","AddressCityNew","AddressZipNew","AddressCountryNew","AddressPhoneNew"];
      for (i=0;i<required.length;i++) {
        var input = $('#address_form_new #'+required[i]); 
        if ((input.val() == "")) {
          input.addClass("needsfilled");
          input.attr("placeholder", "This field is requried.");
          
        }
    
     else if (value.length < minLength){
         $("#address_form_new input[name='address[phone]']").addClass("needsfilled");
        $("#address_form_new input[name='address[phone]']").attr("placeholder", "Minimum 10 numbers are required");
        
      }
          
      }
            
      if ($(":input").hasClass("needsfilled")) { 
        return false;
      }else {
        $(this).closest('form').submit();
        return true;
      }

    });


   
   
   //check update address required
 $('.update-btn').on('click', function(ev) {
  var minLength = 10;
  ev.preventDefault();
  var form_id = $(this).closest('form').attr('id');
  required = ["address[first_name]","address[last_name]","address[address1]","address[city]","address[zip]","address[phone]"];
  for (i=0;i<required.length;i++) {
    var input = $('#'+form_id+' input[name="'+required[i]+'"]'); 
     var phone = $('#'+form_id+' input[name="address[phone]"]'); 
    if ((input.val() == "")) {
     input.addClass("needsfilled");
     input.attr("placeholder", "This field is requried.");
    } 
  else if(phone.val().length < minLength){
           phone.addClass("needsfilled");
           phone.attr("placeholder", "Minimum 10 numbers are required.");
            
         }
    
    else {
      input.removeClass("needsfilled");
    }
  }
  if ($(":input").hasClass("needsfilled")) { 
    return false;
  }else {
    $(this).closest('form').submit();
    return true;
  }
});
});

// filter show/hide 
// Edit address
$(document).ready(function () {
    $('.editAddress__btn').click(function () {

        $(this).parents('.column-12').siblings().find('.EditAddress__form').slideUp();
        $(this).toggleClass('active-filter');
        $(this).parents('.addressArea').find('.EditAddress__form').slideToggle();
    });

    $('.edit-cancel-btn').click(function () {
        $(this).parents('.addressArea').find('.EditAddress__form').slideUp();
        $('.editAddress__btn').removeClass('active-filter');
    });

    // $('.update-btn').click(function () {
    //     $(this).parents('.addressArea').find('.EditAddress__form').slideUp();
    //     $('.editAddress__btn').removeClass('active-filter');
    // });
});

      $(document).ready(function(){
        errornotice = $("#error");
        successnotice = $("#success");
        emptyerror = "Please fill out this field.";
        emailerror = "Please enter a valid e-mail.";

        $("form#customer_edit_profile").submit(function(){
          required = ["customer_first_name","customer_last_name"];
          email = $("#customer_email");
          for (i=0;i<required.length;i++) {
            var input = $('#'+required[i]);
            if ((input.val() == "") || (input.val() == emptyerror)) {
              input.addClass("needsfilled");
              input.val(emptyerror);
              errornotice.fadeIn(750);
            } else {
              input.removeClass("needsfilled");
            }
          }
          var newpassword = $('#customer_password').val();
          var conformpassword = $('#customer_confirm_password').val();
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
          if(newpassword!='' && newpassword.length <8){newpassword.addClass("needsfilled");newpassword.val('should contain 8 characters').attr('type', 'text');}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else if(newpassword!=conformpassword){
            $('#customer_password').addClass("needsfilled");
            $("#customer_confirm_password").val("Confirm Password not match with password");
            $('#customer_confirm_password').addClass("needsfilled");
            return false;

          }else {

            var $form = $('#customer_edit_profile');
            var formData = new FormData($($form.get(0))[0]);
            $(document).ajaxStart(function(){
              $('#update_profile').attr("disabled", "disabled");
            }).ajaxStop(function(){
              $('#update_profile').removeAttr("disabled");
            });
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/index.php",
              type: 'POST',
              data: formData,
              async: true,
              success: function (data) {
                $form.find('#update_profile').prop('disabled', false);

                if(data=='Success'){
                  alert('Profile Update Sucessfully.');
                }else{
                  alert(data);
                }

              },
              timeout: 5000000, // sets timeout to 5 seconds
              contentType: false,
              processData: false
            });
            return false;
          }
        });
        $("#customer_phone, #AddressPhoneNew, input[name='address[phone]']").bind("keypress", function (e2) {
          var keyCode = e2.which ? e2.which : e2.keyCode

          if ((keyCode == 43)) {
            return true;
          }else if (!(keyCode >= 48 && keyCode <= 57 )){
            return false;
          }

          var minLength = 12;
          var phone = $(this).val();
          if (phone.length > minLength){
            return false;
          }
        });
      });
      $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");$("#customer_password").attr('type', 'password');}});
    })(jQuery);  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !window.DesignMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
    // console.log('blog');
    $(".blogdetailProdSlider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: !1,
    dots: false,
    fade: false,
    responsive: [{
        breakpoint: 991,
        settings: { slidesToShow: 3 }
    }, {
        breakpoint: 750,
        settings: { slidesToShow: 2 }
    },
    {
        breakpoint: 360,
        settings: { slidesToShow: 1 }
    },]
});
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-tiktok"] && !window.DesignMode) return;
  try {
      
(function($){ 
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
  });
});  

$(document).ready(function(){
$(".tikvido").each(function() { 
     if($('.tikvido').hasClass('active')){
       $(".tiktokvideotags .all_btn").removeClass('active');
     }else{
       $('.tiktokvideotags .all_btn').addClass('active')
     }   
    });   
  
 $(document).on('click',".boxVideo__btn",function () {
          var video = $(this).parents('.tiktokChallangeVBox').find("video").get(0);
          video.addEventListener('ended', myHandler, false);
          $(this).toggleClass("active");
          if (video.paused === true) {
            video.play();
            $(this).parents('.tiktokChallangeVBox').addClass("active");
          } else {
            video.pause();
            $(this).parents('.tiktokChallangeVBox').removeClass("active");
          }
          var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari){
            video.addEventListener('ended',function(){
              setTimeout(function(){ video.load();}, 1000);
              $(this).parents(".tiktokChallangeVBox").find(".boxVideo__btn").removeClass("active");
              $(this).parents('.tiktokChallangeVBox').removeClass("active");
            });
          }
          function myHandler(e) {
            $(this).parents(".tiktokChallangeVBox").find(".boxVideo__btn").removeClass("active");
            $(this).parents('.tiktokChallangeVBox').removeClass("active");
          }
        });
  
        $(document).on("click", ".tiktokreadBtn",function () {
          $(this).parent().siblings().removeClass("d-none");
          $(this).parent().addClass("d-none");
        });
        $(document).on("click",".indireviews",function () {          
          $('.reviewresponse').html('<div class="smileyloader text-align-center p-0 mt-2"><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/smile.png?v=1632987124" class="smileyloader__img" alt="" width="50" height="50"></div>');
          var proid = $(this).attr('data-proid');
          //alert(proid);
          $.ajax({
            url: "https://stamped.io/api/widget/reviews?take&storeUrl=www.trulybeauty.com&minRating=4&apiKey=pubkey-y0bQR825X6K52BT67V84qf3OGso3o0&productId="+proid+"&sortReviews=photos",
            type: 'GET',
            dataType: 'json',
            success: function (reviewsresponse) {
              reviewproduct='';
              jQuery.each( reviewsresponse.data, function( i, val ) {
                reviewproduct +='<div class="p-4 px-0 mb-2 Product__ReviewBox border0"><div class="gridrow">';
                if(typeof val.reviewUserPhotos !== "undefined" && val.reviewUserPhotos !== null && val.reviewUserPhotos !== ''){
                  var firstimg = val.reviewUserPhotos.split(',');
                  reviewproduct +='<div class="column-12 column-sm-3 column-md-3 column-lg-2"><div class="textCenter Product__ReviewImg"><img src="https://cdn.stamped.io/tr:h-180,/uploads/photos/'+firstimg[0]+'"class="full_img"></div></div>';
                }
                reviewproduct +='<div class="column-12 column-sm-9 column-md-9 column-lg-10"><div class="ProductReview__cntnt"><div class="d-flex justifyBetween ProductReview__starDate"><span class="stamped-starrating stamped-badge-starrating" aria-hidden="true">';
                if(val.reviewRating==5){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>';
                }
                if(val.reviewRating==4){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                if(val.reviewRating==3){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                if(val.reviewRating==2){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                if(val.reviewRating==1){
                  reviewproduct +='<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>';
                }
                reviewproduct +='</span><p>'+val.reviewDate+'</p></div> <div class="Review__contentHolder"><h5 class="textUppercase">'+val.reviewTitle+'</h5><p>'+val.reviewMessage+'</p><h5 class="m-0 py-3 BuyerVerified">'+val.author+'<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/verified.png?v=1632733611">Verified Buyer</span></h5></div><div class="d-flex justifyBetween Review__recomendHelp"><div class="Review__recomended"><p><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/recommend.png?v=1632733611">Yes,<span>I recommend this product</span></p></div><div class="Review__helpful"><p>Was this review helpful?<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/thumsup.png?v=1632733611"></span>'+val.reviewVotesUp+'<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/greythumdown.png?v=1656067772"></span>'+val.reviewVotesDown+'</p></div></div></div></div></div></div>';
              });
              $('.reviewresponse').html(reviewproduct);
              //$('.totlreview').html(reviewsresponse.total);
              //$('.rating').html(reviewsresponse.rating);
            },
            timeout: 5000000, // sets timeout to 5 seconds

          });
        });

      });
    })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !window.DesignMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
     $('.tabsBlogpage').each(function () {
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
            $($(this).attr('href')).hide();
        });
        $(this).find('a').click(function (e) {
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return false;
        });
    });
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bundle-builder"] && !window.DesignMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
console.log('builderpage');
       $.ajax({ type: 'POST',  dataType: 'json',  url: '/cart/clear.js'  }); 
     $('.qtyInput').val('0');
 // qtyButton plus/mins
let totalCount = 0;
let subtotal = 0;
  let saving = 0;
      let totalsaving= 0;
 let gfiftprice = 0;      
  let discount_pro = '';
$(document).on('click', '.bt_ss', function () {
  
    let rp = parseFloat($(this).parents('.qtyCalculator').attr('data-rp'));
    var qty = parseInt($(this).parents('.qtyCalculator, .qtyCal').find('.qtyInput').val());
    var act = $(this).data('type');
    var line = $(this).data('line');
       if (act == 'plus') {
        totalCount++;
         subtotal = parseFloat(parseFloat(subtotal) + rp).toFixed(2) ;
         saving = parseFloat(parseFloat(saving) + rp).toFixed(2) ;
          if (totalCount == 2) {
            $('.unlock-gift-1').addClass('show--gift');
              $('.unlock-gift-1 .flavorValue').val(1);
             gfiftprice = 1; 
          if(gfiftprice == 1){
               saving = parseFloat(parseFloat(saving) + 20).toFixed(2);   
               gfiftprice = 0
             }   }
        if (totalCount == 3) {
          $('.unlock-gift-2').addClass('show--gift');
           $('.unlock-gift-2 .flavorValue').val(1);
           gfiftprice = 1; 
          if(gfiftprice == 1){
               saving = parseFloat(parseFloat(saving) + 10).toFixed(2);   
               gfiftprice = 0
             }   }
        if (totalCount == 6) {
              $('.unlock-gift-3').addClass('show--gift');
            $('.unlock-gift-3 .flavorValue').val(1);
           gfiftprice = 1; 
          if(gfiftprice == 1){
               saving = parseFloat(parseFloat(saving) + 250).toFixed(2);   
               gfiftprice = 0
             }    }
    } else {
        if (totalCount >= 1 && qty > 0) {
            totalCount--;
             subtotal = parseFloat(parseFloat(subtotal) - rp).toFixed(2);
          console.log(totalCount);
           if (totalCount == 0) {
                 gfiftprice = 0; 
                 saving = 0;
              }
             if (totalCount == 1) {
                $('.unlock-gift-1').removeClass('show--gift');
            
                $('.unlock-gift-1 .flavorValue').val(0);
                  gfiftprice = 1;  
                 if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp - 10).toFixed(2);   
                  gfiftprice = 0
                }  
              }
           if (totalCount == 2) {
              $('.unlock-gift-2').removeClass('show--gift');
                   gfiftprice = 1; 
                   if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp - 20).toFixed(2);   
                  gfiftprice = 0
                }  
               }
            if (totalCount == 3) {
               // $('.unlock-gift-2').removeClass('show--gift');
                 $('.unlock-gift-2 .flavorValue').val(0);
                  gfiftprice = 1; 
                   if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp ).toFixed(2);   
                  gfiftprice = 0
                }  
               }
           if (totalCount == 4) {
              //  $('.unlock-gift-2').removeClass('show--gift');
                 $('.unlock-gift-2 .flavorValue').val(0);
                  gfiftprice = 1; 
                   if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp ).toFixed(2);   
                  gfiftprice = 0
                }  
               }
            if (totalCount == 5) {
                $('.unlock-gift-3').removeClass('show--gift');
                $('.unlock-gift-3 .flavorValue').val(0);
               gfiftprice = 1; 
                if(gfiftprice == 1){ saving = parseFloat(parseFloat(saving) - rp - 250).toFixed(2);   
                  gfiftprice = 0
                }  
             }
        } 
  }
  



  
    if (qty > 9999) { var qty = 9999 }
    if (act == 'plus') { if (qty < 9999) { qty++; } } else {
        if (qty > 0) { qty--; }
    }
 
    if (qty >= 1) {
        $(this).parents('.bundle-select--box').addClass('select-bundle');
       }
    else {
        $(this).parents('.bundle-select--box').removeClass('select-bundle');
    }
    qty = (isNaN(qty)) ? 1 : qty;

    $(this).parent('.qtyCalculator').find('.qtyInput').val(qty);
    $('.trulySidebarModel__cartList').addClass('active');
    $('.cartTable').addClass('active');
    var variantid = parseInt($(this).data('variantid'));
    
  totalsaving = parseFloat(saving - subtotal ).toFixed(2);
    //  console.log(totalsaving);
    if(totalsaving == 0.00){
      $('.stock--actionTxt.medium.bundle-cartTotal-inner').css('display','none');
    }else{
      $('.stock--actionTxt.medium.bundle-cartTotal-inner').css('display','flex');
    }
    if($('.unlock-gift-1').hasClass("show--gift") && $('.unlock-gift-2').hasClass("show--gift") && $('.unlock-gift-3').hasClass("show--gift")){
        discount_pro = 'BB_THREE';
  $('.gift_count_text').html(3);
         }
    else if($('.unlock-gift-1').hasClass("show--gift") && $('.unlock-gift-2').hasClass("show--gift")){
         discount_pro = 'BB_TWO';
       $('.gift_count_text').html(2);
     }
    else if ($('.unlock-gift-1').hasClass("show--gift"))  {
       discount_pro = 'BB_ONE';
       $('.gift_count_text').html(1);
         }
   else{
        discount_pro = ''
     }
    var save = ((parseInt(saving)-parseInt(subtotal))/parseInt(saving))*100 ;
    var savepersentage =  save.toFixed(2);
     $(".subtotal").html(subtotal)
     $(".saving").html(saving)
      $(".savepersentage").html(savepersentage)
 if (totalCount >= 1) {
  $('.addtocart_ss').removeClass('disabled');
 }else{
   $('.addtocart_ss').addClass('disabled');
 }
 });
 $(' .addtocart_ss').on('click', function(){
  var inputs = $(".flavorValue");
  var variants = [];
        for(var i = 0; i < inputs.length; i++){
            if($(inputs[i]).val()>=1)
                variants.push({
                    quantity: $(inputs[i]).val(),
                    id: $(inputs[i]).data('variantid'),
                   });
              }
       $.ajax({
                url: "/cart/add.js",
                type: 'POST',
                dataType: 'json',
                data: { items: variants },
                success: function (response) {
               //ajaxfetchCart();
              document.location.href = '/cart/checkout?discount='+discount_pro;
                    }
                });
 
});
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'scroll',
      offset: 1000,
      callback : loadstampedreviews
    });
  });
  function loadstampedreviews(){
    console.log('sdsdfsd');
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
          //  lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      // Possibly fall back to event handlers here
    }
       StampedFn.reloadUGC();
  }
  (function($){
  $(document).ready(function(){
  //console.log('select');
  $(document).on("click", ".select__custom", (function () {
  $(this).toggleClass("openDropdown"),
  $(this).find(".product__shop__categoryList").toggle()
    }
   ));
  });
        })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
     method: 'scroll',
    offset: 1000,
    callback : loadstampedreviews
  });
});
function loadstampedreviews(){
  console.log('sdsdfsd');
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
        //  lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Possibly fall back to event handlers here
  }
     StampedFn.reloadUGC();  
}   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-2024"] && !window.DesignMode) return;
  try {
    
 
(function($){    

   $(document).ready(function() {
     $('.product-form__variants').on('change', function() {
      var selectedValue = $(this).val();
    $('.subscription_product').val(selectedValue);
     $('.subscription_var_price').addClass('var_change');
  });
});
  
  function productvariation_switch(){
     
          var variationID = $('.product-form__variants option:selected').val();
          var productUrl = $('.productDetail input[name="producthandle"]').val();
          var onetimesubscribeoption = $('input[type=radio][name=sellingplan_option]:checked').val();
          jQuery.getJSON(productUrl + '.js', function(product) {
            $.each(product.variants, function(i){
              if( product.variants[i].id == variationID ){
                var price = product.variants[i].price;
            var compare_price = product.variants[i].compare_at_price;
                if(product.variants[i].featured_media!=null){
                  var variantimageID = product.variants[i].featured_media.id;

             
                }
            if(typeof onetimesubscribeoption !== "undefined" && onetimesubscribeoption=='subscription'){ //
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                   $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                   $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                    $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  var sellingplan = $('select[name="selling_plan"]').val();
                  $.each(product.variants[i].selling_plan_allocations, function(j){
                    if(sellingplan==product.variants[i].selling_plan_allocations[j].selling_plan_id){
                      var price = product.variants[i].selling_plan_allocations[j].price;
                      $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                    }
                  });
                }else{
                if(product.variants[i].selling_plan_allocations!=''){
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                  $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                        $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                }
                  $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(price, theme.moneyFormat));

                }
                if(variantimageID){
                  $('.productSliderNav img').each(function(){
                    if ($(this).attr("id") == variantimageID) {
                      $(this).click();
                      $(this).parent().parent().addClass('slick-current');
                    }
                  });
                }
    // console.log("price:",price);
    // document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", price);
    // window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    // window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
              }
            })

          });
        }
$(document).ready(function(){  
productvariation_switch();
$('.product-form__variants').on('change', function() {
productvariation_switch();
});
  
$(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
      $(".sticky-wrap").addClass('sticky-show')
      //$(".head-order-btn").addClass('sticky-hide-head')
    } else {
      $(".sticky-wrap").removeClass('sticky-show')
     // $(".head-order-btn").removeClass('sticky-hide-head')
    }
});
  

});
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'scroll',
        offset: 1000,
         callback : loadstampedreviews
      });
    });
    function loadstampedreviews(){
      var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
      if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
            //  lazyImage.srcset = lazyImage.dataset.srcset;
              lazyImage.classList.remove("lazy");
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      } else {
        // Possibly fall back to event handlers here
      }
         StampedFn.reloadUGC();
    }
  // sortby
  $(".sortBy_fl").click(function() {
              var is_open = $(this).hasClass("open");
              if (is_open) {
                  $(this).removeClass("open");
              } else {
                  $(this).addClass("open");
              }
  });

  $(".sortBy_fl li").click(function() {
              var selected_value = $(this).html();
              var first_li = $(".sortBy_fl li:first-child").html();

              $(".sortBy_fl li:first-child").html(selected_value);
              $(this).html(first_li);
  });

  $(document).mouseup(function(event) {
              var target = event.target;
              var select = $(".sortBy_fl");

              if (!select.is(target) && select.has(target).length === 0) {
                  select.removeClass("open");
              }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-slider"] && !window.DesignMode) return;
  try {
    
  (function($){
    $(document).ready(function(){
     
  function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 1;
  console.log(firstElement);
  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}

if($(window).width() < 750) {
    window.addEventListener('load', Marquee('.marquee_scroll', 0.1))
} else {
    window.addEventListener('load', Marquee('.marquee_scroll', 0.2))
}
      
    });
 
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minibar"] && !window.DesignMode) return;
  try {
    
 (function($){
      $(document).ready(function(){
        $(".smoothScroll").on('click', function(event) {

          if (this.hash !== "") {
            event.preventDefault();
            // Store hash
            var hash = this.hash;
            $('html, body').animate({ scrollTop: $(hash).offset().top}, 800, function(){ });
          } // End if
        });
      });
    $('.show-hideToggle').click(function() {
            $('.faq-content-wrap').slideToggle("150");
            $(this).toggleClass('toggled-on')
        });;

        
        $('.js-faq-title').on('click', function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass('open-faq', 200);
        });
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minis-offer-collection-grid"] && !window.DesignMode) return;
  try {
    
  (function($){   
$(document).ready(function(){
$(".shop_slider_three").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    infinite: true,

    responsive: [
    { breakpoint: 1101, settings: { slidesToShow: 3,} },
    { breakpoint: 751, settings: { slidesToShow: 2,} },
    { breakpoint: 481, settings: { slidesToShow: 2,slidesToScroll: 2,arrows: false,dots: true} },  
    ],
    });
  $('body').on('click', '.slick-arrow', function () {
    loadstampedreviews();
})
    });
})(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minis_client_logo"] && !window.DesignMode) return;
  try {
    
  (function($){   
$(document).ready(function(){
  console.log('sliderlogosse')
$(".loved--brand").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: true,
    responsive: [
        { breakpoint: 989, lazyLoad: 'progressive', settings: "unslick", },
    ],
    });
$(".logo--carousel").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: true,
    responsive: [
        { breakpoint: 989, lazyLoad: 'progressive', settings: "unslick", },
    ],
});
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minis_reviews"] && !window.DesignMode) return;
  try {
    
  (function($){   
$(document).ready(function(){
  $(".fullWide_testimonial").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1, }},
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 }}
    ]
});
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-popular-shave-routine"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
  var wow = new WOW(
    {
        boxClass: 'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset: 0,          // distance to the element when triggering the animation (default is 0)
        mobile: true,       // trigger animations on mobile devices (default is true)
        live: true,       // act on asynchronously loaded content (default is true)
        callback: function (box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
    }
);
wow.init();

  
         });
  
 
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-bag-collection"] && !window.DesignMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
  // $(".newarrival").slick({
  //           slidesToShow: 4,
  //           slidesToScroll: 1,
  //           arrows: true,
  //           adaptiveHeight: !1,
  //           dots: false,
  //           fade: false,
  //           infinite: false,
  //           prevArrow: $(".favPrev__btn_nw"),
  //           nextArrow: $(".favNext__btn_nw"),
  //           responsive: [{
  //               breakpoint: 990,
  //               settings: { slidesToShow: 3 }
  //           }, {
  //               breakpoint: 751,
  //               settings: { slidesToShow: 2 }
  //           },]
  //       });
      // $(".shopbestseller").slick({
      //       slidesToShow: 4,
      //       slidesToScroll: 1,
      //       arrows: true,
      //       adaptiveHeight: !1,
      //       dots: false,
      //       fade: false,
      //       infinite: false,
      //       prevArrow: $(".favPrev__btn_nws"),
      //       nextArrow: $(".favNext__btn_nws"),
      //       responsive: [{
      //           breakpoint: 990,
      //           settings: { slidesToShow: 3 }
      //       }, {
      //           breakpoint: 751,
      //           settings: { slidesToShow: 2 }
      //       },]
      //   });
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-blog-homepage"] && !window.DesignMode) return;
  try {
    
(function($){ 
console.log('blogslider');
$(document).ready(function(){
    $('.blogmainslider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
});
});
})(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offerTestBanner"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
  console.log('sticky');
  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
        $(".sticky-wrap").addClass('sticky-show')
    } else {
        $(".sticky-wrap").removeClass('sticky-show')
    }
});
  });
  })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offerTestProducts"] && !window.DesignMode) return;
  try {
    
(function($){ 
console.log('offerproductssecs');
$(document).ready(function(){
   // $( '#toggleButton' ).prop('checked', false);
   $.ajax({ type: 'POST',   url: '/cart/clear.js'  }); 
$("#toggleButton").on("change", function() {
                if ($(this).is(":checked")) {
                  console.log('sdd');
                  $(".selling_plan").attr("name", "selling_plan");
                    $(".first_row_points").css("display", "none");
                    $(".second_row_points").css("display", "block");
                } else {
                  console.log('qweqwe');
                  $(".selling_plan").attr("name", "");
                    $(".first_row_points").css("display", "block");
                    $(".second_row_points").css("display", "none");
                }
            }); 
        });
      })(jQuery);  
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-shave-lander"] && !window.DesignMode) return;
  try {
    
    (function($){
            $(document).on("click", '.bd_stepWrap.active_bd, .bd_stepWrap.current', function (e) {
            let byoId = e.target.id.split("step-")[1]
            if(byoId){
                $(".bd_pack_cartItems").hide()
                $(`#${byoId}`).fadeIn()
            }
        })

        $('.packBtnClick').click(function (e) {
           // $(this).parents(".bd_packColumn").siblings().find(".packBtnClick span").text("Add To bundle")
           // $(this).find("span").text("Added")

            let parentsTarget = $(e.target).parents(".bd_pack_cartItems")
            let parentTarget = $(e.target).parents(".bd_packProduct_box")
            let img = $(parentTarget).find(".bd_packProduct__img img")
            $(`#${parentTarget[0].dataset.id} img `).attr("src", img[0].src)

            let productId = $(this).attr('data-product-id');
            $(`#${parentTarget[0].dataset.id} img `).attr("data-variant-id", productId);
            console.log(productId);
            let dataKey = $(this).attr('data-key');
            $(`#${parentTarget[0].dataset.id} img `).attr("data-key", dataKey);
            console.log(dataKey);
            let dataProperty = $(this).attr('data-property');
            $(`#${parentTarget[0].dataset.id} img `).attr("data-property", dataProperty);
            console.log(dataProperty);
            
           // let text = $(this).siblings(".bd_packProduct__title").text()
           // console.log("text", text)
            // $(`#${parentTarget[0].dataset.id} + p`)[0].innerText = text


            $(`#step-${parentsTarget[0].id}`).addClass("active_bd")
            $(`#step-${parentsTarget[0].id}`).removeClass("current")
            $(`#step-${parentsTarget[0].id}`).next().addClass("current")

            if ($(this).parents(".bd_packColumn").hasClass("bd_activePack")) {
                $(this).parents(".bd_packColumn").siblings().removeClass("bd_disablePack")
                $(this).parents(".bd_packColumn").removeClass("bd_activePack")
                $(this).parents(".bd_pack_cartItems").removeClass("active")

                

                $(".bd_sticky_sec").removeClass("bd_sticky_active")
                let dataSrc = $(`#${parentTarget[0].dataset.id} img`)
                $(`#${parentTarget[0].dataset.id} img `).attr("src", dataSrc[0].dataset.src)
            } else {
                $(this).parents(".bd_packColumn").siblings().removeClass("bd_activePack")
                $(this).parents(".bd_packColumn").siblings().addClass("bd_disablePack")
                $(this).parents(".bd_packColumn").removeClass("bd_disablePack")
                $(this).parents(".bd_packColumn").addClass("bd_activePack")
                $(this).parents(".bd_pack_cartItems").addClass("active")
                $(".bd_sticky_sec").addClass("bd_sticky_active")

                $(`#${parentTarget[0].dataset.id} .bd_remove-pack`).addClass("bd_show-pack")

            }

            // 
            let bd_pack_cartItems = document.querySelectorAll(".bd_pack_cartItems")
            let bd_pack_cartItemsActive = document.querySelectorAll(".bd_pack_cartItems.active")
            let activeDiv = []
            let lastElement = bd_pack_cartItems[bd_pack_cartItems.length - 1];
            for (var i in bd_pack_cartItems){
               // console.log("lastElement: ", lastElement)
                if(typeof bd_pack_cartItems[i] == 'object'){
                    if(!bd_pack_cartItems[i].classList.contains("active")){
                        activeDiv.push(bd_pack_cartItems[i])
                    }
                }
                
            }
            
           // console.log("activeDiv: ", activeDiv)
            if(!activeDiv.length){
                $(".bd_Pack_Btn .common-btn").removeClass("disabled_btn")
                $(".free_bd .p_show").hide()
                $(".free_bd .p_hide").show()
                $(".psl_btn").addClass("mobileShow")
                $(".bd_pack_cartItems ").addClass("mobileHide");
              
            }else{
                $(".bd_pack_cartItems").hide()
                $(".free_bd .p_hide").hide()
                $(".psl_btn").removeClass("mobileShow")
                $(".bd_pack_cartItems ").removeClass("mobileHide")
            }
            $(activeDiv[0]).fadeIn()
            // scrollToBottom(activeDiv[0], $(this).parents(".bd_pack_cartItems"))
        });

        $('.bd_remove-pack').click(function (e) {

            // let dataText = $(this).parent().siblings("p")
            // console.log("dataText: ", dataText[0].dataset.text)
            // if(dataText.length && dataText[0].dataset.text){
            //     dataText[0].innerText = dataText[0].dataset.text
            // }

            var variantId = $(this).data('variant-id');
            var key = $(this).data('key');
            var property = $(this).data('property');

            $(this).siblings('img').removeAttr('data-variant-id').removeAttr('data-key').removeAttr('data-property');
            

            $(this).removeClass("bd_show-pack")
            let dataSrc = e.target.nextElementSibling.dataset.src
            e.target.nextElementSibling.src = dataSrc 
            $(this).siblings("img").removeAttr("data-variant-id data-key data-property");
            let removedId = $(this).parent(".bd_Pack_img")[0].id
            let bd_packProduct_box = document.querySelectorAll(".bd_packProduct_box")

            //console.log("removedId: ", removedId)            
           // console.log("bd_packProduct_box: ", bd_packProduct_box)            

            for (var x in bd_packProduct_box) {
                if (bd_packProduct_box[x].dataset && removedId == bd_packProduct_box[x].dataset.id) {
                    bd_packProduct_box[x].parentNode.classList.remove("bd_activePack", "bd_disablePack")
                    $(bd_packProduct_box[x]).parents(".bd_pack_cartItems").removeClass("active")
                    // console.log("$(bd_packProduct_box[x]).parent", bd_packProduct_box[x])
                    // bd_packProduct_box[x].querySelector(".packBtnClick span").innerText = "Add To bundle"
                }
            }

            // 
            let bd_pack_cartItems = document.querySelectorAll(".bd_pack_cartItems")
            let activeDiv = []
            for (var i in bd_pack_cartItems){
                // console.log("bd_pack_cartItems: ", bd_pack_cartItems[i])
                if(typeof bd_pack_cartItems[i] == 'object' && !bd_pack_cartItems[i].classList.contains("active")){
                    activeDiv.push(bd_pack_cartItems[i])
                }
                
            }
            $('.bd_pack_cartItems').hide()
            $(activeDiv[0]).fadeIn()
            let removeId = e.target.id.split("remove-")[1]
            if(removeId){
                $(`#step-${removeId}`).removeClass("active_bd")
                $(".bd_pack_cartItems ").removeClass("mobileHide")
                $(".psl_btn").removeClass("mobileShow")
            }else{
                $(`#step-${activeDiv[0].id}`).removeClass("active_bd")
            }
            $('.bd_stepWrap ').removeClass("current")
            $(`#step-${activeDiv[0].id}`).addClass("current")
            
            $(".bd_Pack_Btn .common-btn").addClass("disabled_btn")
            $(".free_bd .p_hide").hide()
            $(".free_bd .p_show").show()
            // scrollToBottom(activeDiv[0], $(this).parents(".bd_pack_cartItems"))

        });


        $(".bd_close_sticky").click((function () {
            $(this).parents(".bd_sticky_sec").addClass("minimize_sticky")
        }))

        if ($(window).width() > 750) {
            $(".bd_Pack_ItemsTitle").click((function () {
                $(this).parents(".bd_sticky_sec").removeClass("minimize_sticky")
            }))
        } 
        
        // else {
        //     $(".bd_Pack_ItemsTitle").click((function () {
        //         $(this).parents(".bd_sticky_sec").toggleClass("minimize_sticky")
        //     }))
        // }



        $(".bd_close_sticky").click((function () {
            $(this).parents(".bd_sticky_sec").addClass("minimize_sticky")
        }))  

       
  $('.bd_Pack_Btn button, .buldPackBtn button').click(function (e) {
      e.preventDefault(); 
      let lineItems = []; 
      $('.bd_Pack_Item').each(function() {
          let $img = $(this).find('.bd_Pack_img img');
          let properties = {};
            properties[$img.data('key')] = $img.data('property');
          let productId = $img.attr('data-variant-id');
          let quantity = 1; 
          let lineItem = {
              id: productId,
              quantity: quantity,
              properties: properties
          }; 
          lineItems.push(lineItem);
      });

       console.log('lineItems:', lineItems);
      $.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          success: function() { 
              $.ajax({
                  url: '/cart/add.js',  
                  method: 'POST',
                  data: JSON.stringify({ items: lineItems }),
                  contentType: 'application/json',
                  dataType: 'json',
                  success: function(response) {
                      // Handle success response
                      console.log('Products added to cart successfully:', response);
                      // Redirect to the cart page or update the cart preview
                      window.location.href = '/cart'; // Redirect to the cart page
                  },
                  error: function(xhr, status, error) { 
                      console.error('Error adding products to cart:', error);
                  }
              });
          },
          error: function(xhr, status, error) {
              console.error('Error clearing cart:', error);
          }
      });
  });
        document.addEventListener('DOMContentLoaded', function() {
    const body = document.querySelector('body');
    if(body.classList.contains('template-pre-shave-lander')) {
      const productLinks = document.querySelectorAll('.cart_productTitle');
      productLinks.forEach(link => {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          const url = new URL('https://www.trulybeauty.com/pages/pre-shave-lander');
          window.location.href = url.toString();
        });
      });
    }
  });
      })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider-section"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 
$(".grand_slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    infinite: true,
    fade: true,
    responsive: [

    ],
});
$('.grand_slider_prev-btn').click(function () {
  $(".grand_slider").slick('slickPrev');
});
$('.grand_slider_next-btn').click(function () {
  $(".grand_slider").slick('slickNext');
});

 $(".grand_slider_btn").hover(
    function () {
        var divTop = $(this).offset().top + 100;
        var windowBottom = $(window).scrollTop() + $(window).height();
        if (divTop < windowBottom) {
            $(this).removeClass("tooltip_top");
        }
    },
    function () {
        $(this).addClass("tooltip_top");
    }
); 

   
});
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productGridSection"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
   $(".pdc--slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: false,
    responsive: [
        { breakpoint: 575, lazyLoad: 'progressive', settings: "unslick", },
    ],
});

       });
})(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productJoinForm"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
console.log('forms');
$("form#pagesubscribeform").submit(function(){
          email = $("#email_coco-cloud");
          if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {
            email.addClass("needsfilled");email.val('Enter valid email address');}
          if ($(":input").hasClass("needsfilled")) {
            return false;
          }else {
            $('button#cococloudsubscribe').css("pointer-events", "none");
            var useremail =$("#email_coco-cloud").val();
            $.ajax({
              url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
              type: 'POST',
              data: {ajaxaction:"subscribelist",subemailaddress:useremail},
              async: true,
              success: function (response) {
                $("form#pagesubscribeform").get(0).reset()
                alert('Thanks for subscribe.');
                $('button#cococloudsubscribe').css("pointer-events", "auto");
              },
              timeout: 5000000, // sets timeout to 5 seconds
            });

            return false;
          }

        });         

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productSlider"] && !window.DesignMode) return;
  try {
    
  (function($){
  $(document).ready(function(){

  // $(".goodiesSlider").slick({
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     arrows: true,
  //     adaptiveHeight: true,
  //     infinite: false,
  //     dots: false,

  //     responsive: [
  //         { breakpoint: 990, settings: { slidesToShow: 3, slidesToScroll: 1 } },
  //         { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  //     ],

  // });
  });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productSliderWithImage"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
$(".goodiesSliderpro").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    infinite: false,
    dots: false,

    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],

});         
});
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producttocart"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function() {
     console.log('mainload');
        // Get the URL query parameters
        const urlParams = new URLSearchParams(window.location.search);
 
        // Check if the 'productids' parameter exists
        if (urlParams.has('productids')) {
            const productids = urlParams.get('productids');
            const productInfo = productids.split(',');
            console.log(productInfo);

            const items = []; // Create an array to store the items

            for (let i = 0; i < productInfo.length; i++) {
                let id = productInfo[i].split(':')[0];
                let qty = productInfo[i].split(':')[1];
                let plan = productInfo[i].split(':')[2];
                let obj = {"id": id, "quantity": qty, "selling_plan": plan };
                items.push(obj); // Push the object into the array
            }

            let newItems = { items: items };
            console.log(newItems);
            console.log("Hello World");
            console.log(items);
            // Clear the cart before adding new items
          clearCart(function() {
              addToCart(newItems);
          });
        }
    });

    // Define the addToCart function outside the document.ready block

    function addToCart(cartData) {
        // Define the URL where you want to send the POST request
        //const addToCartUrl = 'https://www.trulybeauty.com/cart/add.js'; // Replace with your actual Shopify cart endpoint

        console.log(cartData);
        console.log('Hello');

        // Send the data to the server using AJAX

      $.ajax({
        method: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: cartData,
        success: function(){
          console.log("Products added to cart successfully.");
          // Redirect to the checkout page
          window.location.href = '/checkout';
        },
         error: function (jqXHR, exception) {
            console.log("Status: " + jqXHR.status + "Response: " + jqXHR.responseText);
         }
      });

    }

    // Function to clear the cart
  function clearCart(callback) {
      $.ajax({
          method: 'POST',
          url: '/cart/clear.js',
          dataType: 'json',
          success: function(){
              console.log("Cart cleared successfully.");
              if (typeof callback === "function") {
                  callback();
              }
          },
          error: function (jqXHR, exception) {
              console.log("Error clearing cart: Status: " + jqXHR.status + " Response: " + jqXHR.responseText);
              if (typeof callback === "function") {
                  callback();
              }
          }
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quickviewpopup"] && !window.DesignMode) return;
  try {
    

  (function($){
  $(document).ready(function(){



  // $('.product-form__variants').on('change', function() {
  // productvariation_switch();
  // });

  });
        })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-bfcm-sale"] && !window.DesignMode) return;
  try {
    
(function($){
$(document).ready(function () {
 console.log("loading");
$(".slider--wideFade").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1, }},
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 }}
    ]
});
  $(".fancyTwoSlider").slick({
slidesToShow: 2,
slidesToScroll: 2,
arrows: false,
dots: true,
adaptiveHeight: true,
infinite: true,

responsive: [
{ breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1,} },
],
});
});
  })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !window.DesignMode) return;
  try {
    
(function($){ 
//console.log('review');
$(document).ready(function(){
 const smallUspsQuote = Array.from(document.querySelectorAll('.all-usp__StyleQuote .single-usp__StyleQuote'));
        let showElmIndexQuote = 0;
        //console.log(smallUspsQuote);
        setInterval(() => {
            smallUspsQuote.map((item, index) => {
                if (index === showElmIndexQuote) {
                    item.style.display = 'flex';
                    item.style.height = "initial" ;
                    item.style.width = "initial" ;
                    item.style.opacity = "1" ;

                } else {
                    // item.style.display = 'none';
                    item.style.height = "0" ;
                    item.style.width = "0" ;
                    item.style.opacity = "0" ;
                }
            })
            showElmIndexQuote === smallUspsQuote.length - 1 ? showElmIndexQuote = 0 : showElmIndexQuote++;
        }, 2500)

        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review"] && !window.DesignMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
     console.log('sas');
      $(".review--slider").slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: true,
      // centerMode: true,
      // centerPadding: '0',
      responsive: [
      { breakpoint: 990, settings: { slidesToShow: 2, slidesToScroll: 2,  arrows: false, dots: true, } },
      { breakpoint: 751, settings: { slidesToShow: 1, slidesToScroll: 1,  arrows: false, dots: true, } }

      ]
  });
   $(".fancyOneSlider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  adaptiveHeight: true,
  infinite: true,

  responsive: [
  { breakpoint: 990, settings: { slidesToShow: 1, slidesToScroll: 1,} },
  ],
  });
      });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shave-imgpopup"] && !window.DesignMode) return;
  try {
    
 (function($){ 
   console.log('pop');
$(document).ready(function(){ 
  $(".popupSlider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
        { breakpoint: 751, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        // { breakpoint: 481, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ]
});
  
  $(function () {
    "use strict";
    $(".customeImagePopup img").click(function () {
        var $src = $(this).attr("src");
        $(".imagePopupopener").fadeIn(0);
        $(".imagePopupopener__img .imagePopupopener__target").attr("src", $src);
    });

    $(".imagePopupopener__close, .imagePopupopener__overlay").click(function () {
        $(".imagePopupopener").fadeOut(0);
    });

});
  });
 })(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shave-starter-pack-1"] && !window.DesignMode) return;
  try {
    
  (function($){
    console.log('conbinejs');
  document.addEventListener('DOMContentLoaded', function() {
    // Specify the full URL of the specific page you want to clear the cart on
    let url = "https://www.trulybeauty.com/pages/shave-starter-pack";
    if (window.location.href === url) {
        // Use Shopify AJAX API to clear the cart
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        })
        .then(response => {
            // Check if cart was cleared successfully
            if (response.ok) {
                console.log('Cart cleared successfully');
              $(".headerCartItems").html("0");
            } else {
                console.error('Failed to clear cart');
            }
        })
        .catch(error => console.error('Error clearing cart:', error));
    }
});


    $(document).ready(function() {
        function calculateTotalPrice() {
            let totalPrice = 0;
            let countProduct = 0;

            // Loop over each selected product element
            $('.packProduct_Row .activePack').each(function() {
                let price = parseFloat($(this).data('price'));
                let conPrice = price / 100;
                totalPrice += conPrice;
                countProduct++;
            });
          $('.packProduct_Row.free_pro .activePack').each(function() {
                let fprice = parseFloat($(this).data('price'));
                let confPrice = fprice / 100; 
                totalfPrice += confPrice;
            });
          

            let discountedPrice = (totalPrice * 0.85) - totalfPrice;

            // Display the total price
            $('#totalPrice').text('$' + totalPrice.toFixed(2));
            $('#productCount').html(`<b>${countProduct}/5 products selected</b>`);

            // Update button text based on totalPrice
            if (countProduct === 5) {
                $('#addToCartBtn span').html(`BUY NOW <del>$${totalPrice.toFixed(2)}</del> $${discountedPrice.toFixed(2)}`);
            } else {
                $('#addToCartBtn span').text('CHOOSE YOUR SHAVE STARTER PACK');
            }
        }

      $('.packProduct_box').click(function(e) {
    let img = $(e.target).find(".packProduct__img img");
    $(`#${e.target.dataset.id} img `).attr("src", img[0].src);
    $(`#${e.target.dataset.id} .remove-pack`).toggleClass("show-pack");
    if ($(this).parent().hasClass("activePack")) {
        $(this).parent().siblings().removeClass("disablePack");
        $(this).parent().removeClass("activePack");
        $(this).parents(".pack__cartItems").removeClass("active");
        let dataSrc = $(`#${e.target.dataset.id} img`);
        $(`#${e.target.dataset.id} img `).attr("src", dataSrc[0].dataset.src);
    } else {
        $(this).parent().siblings().removeClass("activePack");
        $(this).parent().siblings().addClass("disablePack");
        $(this).parent().removeClass("disablePack");
        $(this).parent().addClass("activePack");
        $(this).parents(".pack__cartItems").addClass("active");
    }

    let selectedProducts = document.querySelectorAll(".activePack");
    // Check if the user has selected all five products
    if (selectedProducts.length === 5) {
        scrollToBottom(document.getElementById('addToCartBtn'));
    } else {
        let pack__cartItems = document.querySelectorAll(".pack__cartItems");
        let activeDiv = [];
        for (var i in pack__cartItems) {
            if (typeof pack__cartItems[i] == 'object' && !pack__cartItems[i].classList.contains("active")) {
                activeDiv.push(pack__cartItems[i]);
            }
        }
        scrollToBottom(activeDiv[0]);
    }

    calculateTotalPrice();
    $('#instruction').hide();
});

$('.remove-pack').click(function(e) {
    $(this).removeClass("show-pack");
    let dataSrc = e.target.nextElementSibling.dataset.src;
    e.target.nextElementSibling.src = dataSrc;
    let removedId = $(this).parent(".selectedPack__img")[0].id;
    let packProduct_box = document.querySelectorAll(".packProduct_box");
    for (var x in packProduct_box) {
        if (packProduct_box[x].dataset && removedId == packProduct_box[x].dataset.id) {
            packProduct_box[x].parentNode.classList.remove("activePack", "disablePack");
            $(packProduct_box[x]).parents(".pack__cartItems").removeClass("active");
        }
    }

    let selectedProducts = document.querySelectorAll(".activePack");
    // Check if the user has selected all five products
    if (selectedProducts.length === 5) {
        scrollToBottom(document.getElementById('addToCartBtn'));
    } else {
        let pack__cartItems = document.querySelectorAll(".pack__cartItems");
        let activeDiv = [];
        for (var i in pack__cartItems) {
            if (typeof pack__cartItems[i] == 'object' && !pack__cartItems[i].classList.contains("active")) {
                activeDiv.push(pack__cartItems[i]);
            }
        }
        scrollToBottom(activeDiv[0]);
    }

    calculateTotalPrice();
});

function scrollToBottom(element) {
    setTimeout(() => {
        if ($(window).width() < 989) {
            $('html, body').animate({
                scrollTop: element.offsetTop - 230
            }, '500');
        } else {
            $('html, body').animate({
                scrollTop: element.offsetTop - 290
            }, '500');
        }
    }, 500);
}

        $('#addToCartBtn').click(function() {
            // Array to store selected products with properties
            var selectedProducts = [];
            var productCount = 0;

            // Loop through each group and get the selected product with its properties
            $('.pack__cartItems').each(function() {
                var selectedProductBtn = $(this).find('.activePack');
                if (selectedProductBtn.length > 0) {
                    var properties = {};
                    // Loop through data attributes of the selected product button to dynamically get key-value pairs
                    selectedProductBtn.each(function() {
                        properties[$(this).data('key')] = $(this).data('property');
                    });
                    var selectedProduct = {
                        id: selectedProductBtn.data('product-id'),
                        properties: properties
                    };
                    selectedProducts.push(selectedProduct);
                    productCount++;
                }
            });

            // Check if all 5 products are selected
            if (productCount < 5) {
                // Array to store text instructions for missing products
                var missingProducts = [];

                // Loop through each group to find missing products
                $('.pack__cartItems').each(function() {
                    var productName = $(this).find('h2').text();
                    if (!$(this).hasClass('active')) {
                        missingProducts.push(productName);
                    }
                });

                // Display text instructions for missing products step-by-step
                var index = 0;
                var showInstruction = function() {
                    if (index < missingProducts.length) {
                        $('#instruction').html(`<b>Please select product from ${missingProducts[index]}</b>`);
                        index++;
                    } else {
                        // All instructions have been shown, proceed to add to cart
                        addToCart(selectedProducts);
                    }
                };

                showInstruction();

                // Bind click event to show the next instruction
                $('#instruction').click(showInstruction);

                // Show instruction element
                $('#instruction').show();
            } else {
                // All 5 products are selected, proceed to add to cart
                addToCart(selectedProducts);
            }
        });
      // Function to add products to the cart
function addToCart(products) {
    // Clear the cart first
    $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        success: function() {
            // Once the cart is cleared, add the new products
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    items: products // Send the array of selected products with properties
                },
                dataType: 'json',
                success: function(data) {
                    // Handle success, such as displaying a success message
                    console.log('Products added to cart:', data);
                    window.location.href = '/cart'; // Redirect to the cart page
                },
                error: function(xhr, status, error) {
                    // Handle errors, such as displaying an error message
                    console.error('Error adding products to cart:', error);
                }
            });
        },
        error: function(xhr, status, error) {
            console.error('Error clearing cart:', error);
            // If there's an error clearing the cart, handle it accordingly
            // For example, you can still try to add the new products or display an error message
        }
    });
}


        calculateTotalPrice();
    });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shave-starter-pack"] && !window.DesignMode) return;
  try {
    
  (function($){
    console.log('conbinejs');
  document.addEventListener('DOMContentLoaded', function() {
    // Specify the full URL of the specific page you want to clear the cart on
    let url = "https://www.trulybeauty.com/pages/shave-starter-pack";
    if (window.location.href === url) {
        // Use Shopify AJAX API to clear the cart
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        })
        .then(response => {
            // Check if cart was cleared successfully
            if (response.ok) {
                console.log('Cart cleared successfully');
              $(".headerCartItems").html("0");
            } else {
                console.error('Failed to clear cart');
            }
        })
        .catch(error => console.error('Error clearing cart:', error));
    }
});


    $(document).ready(function() {
        function calculateTotalPrice() {
            let totalPrice = 0;
            let countProduct = 0;

            // Loop over each selected product element
            $('.packProduct_Row .activePack').each(function() {
                let price = parseFloat($(this).data('price'));
                let conPrice = price / 100;
                totalPrice += conPrice;
                countProduct++;
            });
          $('.packProduct_Row.free_pro .activePack').each(function() {
                let fprice = parseFloat($(this).data('price'));
                let confPrice = fprice / 100; 
                totalfPrice += confPrice;
            });
          

            let discountedPrice = (totalPrice * 0.85) - totalfPrice;

            // Display the total price
            $('#totalPrice').text('$' + totalPrice.toFixed(2));
            $('#productCount').html(`<b>${countProduct}/5 products selected</b>`);

            // Update button text based on totalPrice
            if (countProduct === 5) {
                $('#addToCartBtn span').html(`BUY NOW <del>$${totalPrice.toFixed(2)}</del> $${discountedPrice.toFixed(2)}`);
            } else {
                $('#addToCartBtn span').text('CHOOSE YOUR SHAVE STARTER PACK');
            }
        }

      $('.packProduct_box').click(function(e) {
    let img = $(e.target).find(".packProduct__img img");
    $(`#${e.target.dataset.id} img `).attr("src", img[0].src);
    $(`#${e.target.dataset.id} .remove-pack`).toggleClass("show-pack");
    if ($(this).parent().hasClass("activePack")) {
        $(this).parent().siblings().removeClass("disablePack");
        $(this).parent().removeClass("activePack");
        $(this).parents(".pack__cartItems").removeClass("active");
        let dataSrc = $(`#${e.target.dataset.id} img`);
        $(`#${e.target.dataset.id} img `).attr("src", dataSrc[0].dataset.src);
    } else {
        $(this).parent().siblings().removeClass("activePack");
        $(this).parent().siblings().addClass("disablePack");
        $(this).parent().removeClass("disablePack");
        $(this).parent().addClass("activePack");
        $(this).parents(".pack__cartItems").addClass("active");
    }

    let selectedProducts = document.querySelectorAll(".activePack");
    // Check if the user has selected all five products
    if (selectedProducts.length === 5) {
        scrollToBottom(document.getElementById('addToCartBtn'));
    } else {
        let pack__cartItems = document.querySelectorAll(".pack__cartItems");
        let activeDiv = [];
        for (var i in pack__cartItems) {
            if (typeof pack__cartItems[i] == 'object' && !pack__cartItems[i].classList.contains("active")) {
                activeDiv.push(pack__cartItems[i]);
            }
        }
        scrollToBottom(activeDiv[0]);
    }

    calculateTotalPrice();
    $('#instruction').hide();
});

$('.remove-pack').click(function(e) {
    $(this).removeClass("show-pack");
    let dataSrc = e.target.nextElementSibling.dataset.src;
    e.target.nextElementSibling.src = dataSrc;
    let removedId = $(this).parent(".selectedPack__img")[0].id;
    let packProduct_box = document.querySelectorAll(".packProduct_box");
    for (var x in packProduct_box) {
        if (packProduct_box[x].dataset && removedId == packProduct_box[x].dataset.id) {
            packProduct_box[x].parentNode.classList.remove("activePack", "disablePack");
            $(packProduct_box[x]).parents(".pack__cartItems").removeClass("active");
        }
    }

    let selectedProducts = document.querySelectorAll(".activePack");
    // Check if the user has selected all five products
    if (selectedProducts.length === 5) {
        scrollToBottom(document.getElementById('addToCartBtn'));
    } else {
        let pack__cartItems = document.querySelectorAll(".pack__cartItems");
        let activeDiv = [];
        for (var i in pack__cartItems) {
            if (typeof pack__cartItems[i] == 'object' && !pack__cartItems[i].classList.contains("active")) {
                activeDiv.push(pack__cartItems[i]);
            }
        }
        scrollToBottom(activeDiv[0]);
    }

    calculateTotalPrice();
});

function scrollToBottom(element) {
    setTimeout(() => {
        if ($(window).width() < 989) {
            $('html, body').animate({
                scrollTop: element.offsetTop - 230
            }, '500');
        } else {
            $('html, body').animate({
                scrollTop: element.offsetTop - 290
            }, '500');
        }
    }, 500);
}

        $('#addToCartBtn').click(function() {
            // Array to store selected products with properties
            var selectedProducts = [];
            var productCount = 0;

            // Loop through each group and get the selected product with its properties
            $('.pack__cartItems').each(function() {
                var selectedProductBtn = $(this).find('.activePack');
                if (selectedProductBtn.length > 0) {
                    var properties = {};
                    // Loop through data attributes of the selected product button to dynamically get key-value pairs
                    selectedProductBtn.each(function() {
                        properties[$(this).data('key')] = $(this).data('property');
                    });
                    var selectedProduct = {
                        id: selectedProductBtn.data('product-id'),
                        properties: properties
                    };
                    selectedProducts.push(selectedProduct);
                    productCount++;
                }
            });

            // Check if all 5 products are selected
            if (productCount < 5) {
                // Array to store text instructions for missing products
                var missingProducts = [];

                // Loop through each group to find missing products
                $('.pack__cartItems').each(function() {
                    var productName = $(this).find('h2').text();
                    if (!$(this).hasClass('active')) {
                        missingProducts.push(productName);
                    }
                });

                // Display text instructions for missing products step-by-step
                var index = 0;
                var showInstruction = function() {
                    if (index < missingProducts.length) {
                        $('#instruction').html(`<b>Please select product from ${missingProducts[index]}</b>`);
                        index++;
                    } else {
                        // All instructions have been shown, proceed to add to cart
                        addToCart(selectedProducts);
                    }
                };

                showInstruction();

                // Bind click event to show the next instruction
                $('#instruction').click(showInstruction);

                // Show instruction element
                $('#instruction').show();
            } else {
                // All 5 products are selected, proceed to add to cart
                addToCart(selectedProducts);
            }
        });
      // Function to add products to the cart
function addToCart(products) {
    // Clear the cart first
    $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        success: function() {
            // Once the cart is cleared, add the new products
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    items: products // Send the array of selected products with properties
                },
                dataType: 'json',
                success: function(data) {
                    // Handle success, such as displaying a success message
                    console.log('Products added to cart:', data);
                    window.location.href = '/cart'; // Redirect to the cart page
                },
                error: function(xhr, status, error) {
                    // Handle errors, such as displaying an error message
                    console.error('Error adding products to cart:', error);
                }
            });
        },
        error: function(xhr, status, error) {
            console.error('Error clearing cart:', error);
            // If there's an error clearing the cart, handle it accordingly
            // For example, you can still try to add the new products or display an error message
        }
    });
}


        calculateTotalPrice();
    });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopIndividual-product"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
var pro_length= $('.pro_count').val();
          var slidesToShow = '' ;
          if (pro_length == 3){
            var slidesToShow = pro_length ;
          }
          else{
            var slidesToShow = 4 ;

          }  
  
  //console.log('slidesToShow');
  
$(".goodiesSlider").slick({
          slidesToShow: slidesToShow,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: !1,
            dots: false,
            fade: false,
            infinite: false,
            prevArrow: $(".favPrev__btn"),
            nextArrow: $(".favNext__btn"),
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 751, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],

});   
$(".goodiesSlidernew").slick({
          slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: !1,
            dots: false,
            fade: false,
            infinite: false,
            prevArrow: $(".favPrev__btns"),
            nextArrow: $(".favNext__btns"),
    responsive: [
        { breakpoint: 990, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 751, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],

});   
});
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-free-right-slider"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
  //console.log('numSlide');
  var pro_length= $('.pro_count').val();
// var numSlides = $('.onhalfSliderRight  .slick-slide').length;
//   console.log(pro_length)
if (pro_length <= 2) {
   $('.onhalfSliderRight').addClass('slidesTranslate-sm');
} else {
    $('.onhalfSliderRight').addClass('slidesTranslate-lg');
}
$('.onhalfSliderRight').slick({
    slidesToShow: 1.5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow: $(".onhalfSliderRight__btn.onhalfSliderRight__btnLeft"),
    nextArrow: $(".onhalfSliderRight__btn.onhalfSliderRight__btnRight"),
});  

 });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-with-text"] && !window.DesignMode) return;
  try {
    
(function($){ 
     console.log('etettetete');
     $(document).ready(function () {            
            $(".showcontentMoreBtn").click(function () {
                $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
                $(".sun_list ul").slideToggle();   
            });
     
        });
      })(jQuery);  
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product"] && !window.DesignMode) return;
  try {
    
        (function($){

        // Get the first element with the class name 'glazedDonut_slide_z'
    // const trackedSection = document.querySelector('.glazedDonut_slide_z');

    // let startTime;
    // let endTime;
    // let totalTimeSpent = 0;

    // function startTracking() {
    //     startTime = new Date();
    // }

    // function stopTracking() {
    //     endTime = new Date();
    //     const timeSpent = endTime - startTime;
    //     totalTimeSpent += timeSpent;
    //     console.log("Time spent in this session: " + (timeSpent / 1000) + " seconds");
    // }

    // function sendTimeSpent() {
    //     console.log("Total time spent: " + (totalTimeSpent / 1000) + " seconds");
    // }

    // if (trackedSection) {
    //     trackedSection.addEventListener('mouseenter', startTracking);
    //     trackedSection.addEventListener('mouseleave', stopTracking);
    //     window.addEventListener('beforeunload', sendTimeSpent);
    // } else {
    //     console.error("Element with class 'glazedDonut_slide_z' not found.");
    // }

          // Get the section element
  // const section = document.querySelector('.glazedDonut_slide_z');

  // // Start tracking time when the user enters the section
  // section.addEventListener('mouseenter', function() {
  //   // Get the start time
  //   const startTime = Date.now();

  //   // Start a timer
  //   const timer = setInterval(function() {
  //     // Get the current time
  //     const currentTime = Date.now();

  //     // Calculate the time spent in the section
  //     const timeSpent = currentTime - startTime;

  //     console.log(timeSpent);
  //     // Update the display
  //     //document.querySelector('.time-spent').innerHTML = timeSpent;
  //   }, 1000);

  //   // Stop the timer when the user leaves the section
  //   section.addEventListener('mouseleave', function() {
  //     clearInterval(timer);
  //   });
  // });


        $(document).ready(function(){
            console.log("running");
          $(window).on('scroll', function () {
            const customHeight = 750; // Custom height in pixels
            if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top + customHeight ) {
              $(".sticky-wrap").addClass('sticky-show')
              //$(".head-order-btn").addClass('sticky-hide-head')
            } else {
              $(".sticky-wrap").removeClass('sticky-show')
             // $(".head-order-btn").removeClass('sticky-hide-head')
            }
        });

          if($(window).width() >= 750){
              // Initialize the slick slider for auto-sliding
              $('.productSliderMain').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: true,
                  autoplaySpeed: 2000, // Set the speed of auto-sliding in milliseconds
                  arrows: false, // Hide navigation arrows
                  dots: false // Hide navigation dots
              });

          }

          if($(window).width() <= 750){
          // custom hide productctabar
             $(document).ready(function() {
              var $grabGlowDiv = $('.grab-glow');
              var $stickyButton = $('.product-ctaBar');
              function checkIfInView() {
                var windowTop = $(window).scrollTop();
                var windowBottom = windowTop + $(window).height();
                var divTop = $grabGlowDiv.offset().top;
                var divBottom = divTop + $grabGlowDiv.outerHeight();
                if (divBottom >= windowTop && divTop <= windowBottom) {
                  $stickyButton.removeClass('sticky-show');
                } else {
                  // Remove the 'sticky' class when the div is out of the viewport
                  //$stickyButton.addClass('sticky-show');
                }
              }
              $(window).on('scroll', checkIfInView);
              checkIfInView();
            });
            }

        });
              })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["singleImageText"] && !window.DesignMode) return;
  try {
    
      (function($) {
  $(document).on("click",".addToCart", function(){
    $('.hideformsubmit').trigger('click');
  });

  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialoffer-guaranteeSec"] && !window.DesignMode) return;
  try {
    
  (function($){ 
$(document).ready(function(){
 garunteeSliderMob(".garuntee_carouselSlider", false, false, 1100);
    function garunteeSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 1,
            swipeToSlide: true,
            autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 575,
                settings: { slidesToShow: 2, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialoffer-logo"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
logosecSliderMob(".logosec__slider", true, false, 989);
    function logosecSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 2,
            swipeToSlide: true,
            autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 480,
                settings: { slidesToShow: 3, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }

         });
  
 
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferFaq"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
   
// accordian
$(document).on("click", ".accordian_cm .accordian_toggle, .faqAccordian .faqAccordian__toggle", (function () {
        $(this).parent().siblings().removeClass("active"),
        $(this).parent().siblings().find(".accordian_cntnt,.faqAccordian__cntnt").slideUp(),
        $(this).parent().toggleClass("active"),
        $(this).next(".accordian_cntnt, .faqAccordian__cntnt").slideToggle(200)

            // if ($(window).width() < 990) {
            //     setTimeout(() => {
            //     $('body, html').animate({ scrollTop: $(this).parents('.accordian').offset().top - 98 }, 600)
            //     }, 550)
            // }     
})
              
);  
    });
})(jQuery);  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferGrid"] && !window.DesignMode) return;
  try {
    
  (function($){ 
$(document).ready(function(){
discoverSliderMob(".discover_Slider", false, true, 989);
    function discoverSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 1,
            swipeToSlide: true,
           // autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 750,
                settings: { slidesToShow: 2, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }
    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferImgAnimate"] && !window.DesignMode) return;
  try {
    
  console.log('img');
  (function($) {
    $(document).ready(function(){
    function run_animate() {
      var animation_items = $(".animate");
        
      var ml1 = 0;
      setInterval(function() {
        if (ml1 <= 0 - $(".animate1 .animate-wrapper").width() / 2 - 16) {
          ml1 = 0;
        }

        $(".animate1 .animate-wrapper").css("margin-left", ml1);
        ml1 -= 0.5;
      }, 20);
        
      var ml2 = 0;
      setInterval(function() {
        if (ml2 <= 0 - $(".animate2 .animate-wrapper").width() / 2 - 16) {
          ml2 = 0;
        }

        $(".animate2 .animate-wrapper").css("margin-left", ml2);
        ml2 -= 0.5;
      }, 20);
        
      var ml3 = 0;
      setInterval(function() {
        if (ml3 <= 0 - $(".animate3 .animate-wrapper").width() / 2) {
          ml3 = 0;
        }

        $(".animate3 .animate-wrapper").css("margin-left", ml3);
        ml3 -= 1;
      }, 20);
    }
    
    $(window).on("load", function() {
      run_animate();
    });  
  });
  })(jQuery);     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialOfferPackage"] && !window.DesignMode) return;
  try {
    
  (function($){ 
$(document).ready(function(){
  console.log('package');
  $.ajax({ type: 'POST',  dataType: 'json',  url: '/cart/clear.js'  }); 
  
 packageSliderMob(".package__carousel", false, true, 989);
    function packageSliderMob($slidername, $dots, $arrows, $breakpoint) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 1,
            swipeToSlide: true,
           // autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: "unslick"
                },
                {
                breakpoint: 575,
                settings: { slidesToShow: 2, slidesToScroll: 1, }
                },
            ]
        };
        slider.slick(settings);
        $(window).on("resize", function () {
            if ($(window).width() > $breakpoint) {
                return;
            }
            if (!slider.hasClass("slick-initialized")) {
                return slider.slick(settings);
            }
        });
    }

   $(document).on('click','.bundle_btn',function(e){
    //alert($(this).attr('data-variation-id'));
    var variationid = $(this).attr('data-variation-id');  
     //alert(variationid);
    var quantity = $(this).attr('data-qty'); 
    if(variationid=="39774735106083" && quantity==3){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {items: [{id: variationid,quantity: quantity},{id:32894947917859,quantity:1}]},
          success: function(){ window.location.href = "https://www.trulybeauty.com/checkout";},
          error: function(){alert('Unable to add product to cart.')},
        });
      }else{
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',      
          data: {items: [{id: variationid,quantity: quantity}]},
          success: function(){ window.location.href = "https://www.trulybeauty.com/checkout";},
          error: function(){alert('Unable to add product to cart.')},
        });
      } 
    
   });  

  

    });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-reviews"] && !window.DesignMode) return;
  try {
    
  console.log('review');
(function($) {
    var ajax_rev = ajax_pro = '';
    var productimage1 = productimage2 = variationid = productprice = '';

    function bestsellersreviews() {
        $.ajax({
            url: "https://mytrulydeals.com/trulybeauty/reviews/index.php",
            type: 'GET',
            dataType: 'json',
            success: function(reviewresponse) {
                //console.log(reviewresponse.products);
                reviewresponse.reviews.forEach(function(review, index) {
                    mrgrimge = '';
                    if (review.reviewUserPhotos != '') {
                        review.reviewUserPhotos.split(",").forEach(function(rimage, index) {
                            mrgrimge += '<img src="https://cdn.stamped.io/tr:h-180,/uploads/photos/' + rimage + '"/>';
                        });
                    }

                    ajax_rev += `<div class="pt-5 pb-4 Product__ReviewBox filterid_${review.reviewproductId}">
                        <div class="gridrow">
                            <div class="column-12 column-sm-5 column-md-4 column-lg-3">
                                <div class="text-align-center Product__ReviewImg">
                                    <div class="gridrow g-2">
                                        <div class="column-6"><img src="${review.reviewproductfirstimage}" class="full_img"></div>
                                        <div class="column-6"><img src="${review.reviewproductsecondimage}" class="full_img"></div>
                                    </div>
                                    <h5 class="textUppercase mb-0 mt-10"><a href="${review.reviewproductURL}"><i>${review.reviewproductName}</i></a></h5>
                                    <div class="Review__readMoreBtn my-10"><a href="${review.reviewproductURL}">VIEW DETAIL</a></div>
                                    <form method="post" class='Shopify-product-form' action="/cart/add" id="product_form_${review.reviewproductId}" accept-charset="UTF-8" enctype="multipart/form-data" data-productid="${review.reviewproductId}" novalidate="novalidate" data-product-form="">
                                        <input type="hidden" name="form_type" value="product">
                                        <input type="hidden" name="utf8" value="✓">
                                        <input type="hidden" name="id" value="${review.reviewvariationId}">
                                        <button type="submit" name="add" id="AddToCart-${review.reviewvariationId}" class="common-btn common-btn-round common-btn-black showHeart add-to-cart-ajax add_to_cart">Add to bag <span class="btn_price"><span class="price--on-sale"><span class="money">$${review.reviewproductprice}</span></span></span></button>
                                    </form>
                                    <a target="_blank" class="common-btn common-btn-filled common-btn-black common-btn-full mexico-atc-button d-none" href="https://sephora.com.mx/categories/marcas/truly-beauty">Buy at Sephora</a>
                                </div>
                            </div>
                            <div class="column-12 column-sm-7 column-md-8 column-lg-9">
                                <div class="ProductReview__cntnt">
                                    <div class="d-flex justifyBetween ProductReview__starDate">
                                        <span class="stamped-starrating stamped-badge-starrating" aria-hidden="true">
                                            <i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>
                                            <i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>
                                            <i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>
                                            <i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>
                                            <i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>
                                        </span>
                                        <p>${review.reviewDate}</p>
                                    </div>
                                    <div class="Review__contentHolder">
                                        <h5 class="textUppercase">${review.reviewTitle}</h5>
                                        <p>${review.reviewMessage}</p>
                                        <h5 class="m-0 py-3 BuyerVerified">${review.reviewauthor}<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/verified.png?v=1632733611">Verified Buyer</span></h5>
                                    </div>
                                    <div class="d-flex justify-content-between Review__recomendHelp">
                                        <div class="Review__recomended">
                                            <p><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/recommend.png?v=1632733611">Yes,<span>I recommend this product</span></p>
                                        </div>
                                        <div class="Review__helpful">
                                            <p>Was this review helpful?<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/thumsup.png?v=1632733611"></span>${review.reviewVotesUp}<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/greythumdown.png?v=1656067772"></span>${review.reviewVotesDown}</p>
                                        </div>
                                    </div>
                                    <div class="d-flex-wrap ReviewProduct__images"> ${mrgrimge}</div>
                                </div>
                            </div>
                        </div>
                    </div>`;

                });
                reviewresponse.products.forEach(function(product, index) {
                    ajax_pro += '<li><button class="review__FilterBtn" id="' + product.productid + '">' + product.productname + '</button></li>';
                });
                $('#bestsellerreview').html(ajax_rev);
                $('.productsname').html(ajax_pro);
                size_li = $(".productsname li").length;
                // console.log('size',  size_li);
                x = 5;
                $('.productsname li:lt(' + x + ')').show();
                $('.seemoreover').removeClass('hide');
              checkcountry();
            },
            timeout: 5000000, // sets timeout to 5 seconds

        });
    }
    bestsellersreviews();
    $(document).ready(function() {
        $.ajax({
            url: "https://stamped.io/api/widget/reviews?storeUrl=www.trulybeauty.com&minRating=1&apiKey=pubkey-y0bQR825X6K52BT67V84qf3OGso3o0",
            type: 'GET',
            dataType: 'json',
            success: function(reviewsresponse) { //alert(data);
                // console.log(reviewsresponse.data);
                // var objJSON = JSON.parse(data);
                //console.log(objJSON.total);
                $('.totalreviews').html(reviewsresponse.total);
                //console.log(data.total);
            },
            timeout: 5000000, // sets timeout to 5 seconds

        });
        $('#seemore').click(function() {
            x = (x + 5 <= size_li) ? x + 5 : size_li;
            $('.productsname li:lt(' + x + ')').show();
            size_lis = $(".productsname li:visible").length;

            if (size_li == size_lis) {
                $('#seemore').addClass('hide');
            }
        });
        $(document).on('click', ".productsname button", function() {
            // alert($(this).attr('id'));
            var filterid = $(this).attr('id');

            $(".reviewPageFilter__btn").removeClass("active");
            $(this).addClass('active');
            var ajax_revsg = '';
            $('#bestsellerreview').html('<div class="smileyloader text-align-center p-0 mt-10"><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/truly_logo.gif?v=1685444949" class="" alt="" width="100" height=""></div>');
            $.ajax({
                url: "https://mytrulydeals.com/trulybeauty/reviews/singleproductreviews.php?productid=" + filterid + "",
                type: 'GET',
                dataType: 'json',
                success: function(reviewresponse) {
                    reviewresponse.reviews.forEach(function(review, index) {
                        mrgrimge = '';
                        if (review.reviewUserPhotos != '') {
                            review.reviewUserPhotos.split(",").forEach(function(rimage, index) {
                                mrgrimge += '<img src="https://cdn.stamped.io/tr:h-180,/uploads/photos/' + rimage + '"/>';
                            });
                        }
                        ajax_revsg += '<div class="pt-5 pb-4 Product__ReviewBox filterid_' + review.reviewproductId + '"><div class="gridrow"><div class="column-12 column-sm-5 column-md-4 column-lg-3"><div class="text-align-center Product__ReviewImg"><div class="gridrow g-2"><div class="column-6"><img src="' + review.reviewproductfirstimage + '" class="full_img"></div><div class="column-6"><img src="' + review.reviewproductsecondimage + '" class="full_img"></div></div><h5 class="textUppercase mb-0 mt-10"><a href="' + review.reviewproductURL + '"><i>' + review.reviewproductName + '</i></a></h5><div class="Review__readMoreBtn my-10"><a href="' + review.reviewproductURL + '">VIEW DETAIL</a></div><form method="post" action="/cart/add" id="product_form_' + review.reviewproductId + '" accept-charset="UTF-8" enctype="multipart/form-data" data-productid="' + review.reviewproductId + '" novalidate="novalidate" data-product-form=""><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="' + review.reviewvariationId + '"><button type="submit" name="add" id="AddToCart-' + review.reviewvariationId + '" class="common-btn common-btn-round common-btn-black showHeart add-to-cart-ajax add_to_cart">Add to bag <span class="btn_price"><span class="price--on-sale"><span class="money">$' + review.reviewproductprice + '</span></span></span></button></form></div></div><div class="column-12 column-sm-7 column-md-8 column-lg-9"><div class="ProductReview__cntnt"><div class="d-flex justifyBetween ProductReview__starDate"><span class="stamped-starrating stamped-badge-starrating" aria-hidden="true"><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i></span><p>' + review.reviewDate + '</p></div><div class="Review__contentHolder"><h5 class="textUppercase">' + review.reviewTitle + '</h5><p>' + review.reviewMessage + '</p><h5 class="m-0 py-3 BuyerVerified">' + review.reviewauthor + '<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/verified.png?v=1632733611">Verified Buyer</span></h5></div><div class="d-flex justify-content-between Review__recomendHelp"> <div class="Review__recomended"><p><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/recommend.png?v=1632733611">Yes,<span>I recommend this product</span></p></div><div class="Review__helpful"><p>Was this review helpful?<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/thumsup.png?v=1632733611"></span>' + review.reviewVotesUp + '<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/greythumdown.png?v=1656067772"></span>' + review.reviewVotesDown + '</p></div></div><div class="d-flex-wrap ReviewProduct__images"> ' + mrgrimge + '</div></div></div></div></div>';
                    });
                    $('#bestsellerreview').html('');
                    $('#bestsellerreview').html(ajax_revsg);

                    $('.review__ClearFilterBtn').removeClass('hide');

                },
                timeout: 5000000, // sets timeout to 5 seconds

            });

        });
        $(document).on('click', ".review__ClearFilterBtn", function() {
            location.reload();
        });
        $(document).on('click', ".childproducttype", function() {
            //alert($(this).text());
            responseid = $(this).parent().parent().parent().attr('data-id'); //alert(responseid);
            $('.childproducttype').removeClass('active');
            $(this).addClass('active');
            var producttype = $(this).text();
            $('#' + responseid).html('<div class="smileyloader text-align-center p-0 mt-10"><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/truly_logo.gif?v=1685444949" class="smileyloader__img" alt="" width="100" height=""></div>');
            ajax_crevsg = '';
            $.ajax({
                url: "https://mytrulydeals.com/trulybeauty/reviews/singleproducttypereviews.php?producttype=" + encodeURIComponent(producttype) + "",
                type: 'GET',
                dataType: 'json',
                success: function(creviewresponse) { //alert();
                    creviewresponse.reviews.forEach(function(review, index) {
                        mrgrimge = '';
                        if (review.reviewUserPhotos != '') {
                            review.reviewUserPhotos.split(",").forEach(function(rimage, index) {
                                mrgrimge += '<img src="https://cdn.stamped.io/tr:h-180,/uploads/photos/' + rimage + '"/>';
                            });
                        }
                        ajax_crevsg += '<div class="pt-5 pb-4 Product__ReviewBox filterid_' + review.reviewproductId + '"><div class="gridrow"><div class="column-12 column-sm-5 column-md-4 column-lg-3"><div class="text-align-center Product__ReviewImg"><div class="gridrow g-2"><div class="column-6"><img src="' + review.reviewproductfirstimage + '" class="full_img"></div>';
                        if (review.reviewproductsecondimage != '') {
                            ajax_crevsg += '<div class="column-6"><img src="' + review.reviewproductsecondimage + '" class="full_img"></div>';
                        }
                        ajax_crevsg += '</div><h5 class="textUppercase mb-0 mt-10"><a href="' + review.reviewproductURL + '"><i>' + review.reviewproductName + '</i></a></h5><div class="Review__readMoreBtn my-10"><a href="' + review.reviewproductURL + '">VIEW DETAIL</a></div><form method="post" action="/cart/add" id="product_form_' + review.reviewproductId + '" accept-charset="UTF-8" enctype="multipart/form-data" data-productid="' + review.reviewproductId + '" novalidate="novalidate" data-product-form=""><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="' + review.reviewvariationId + '"><button type="submit" name="add" id="AddToCart-' + review.reviewvariationId + '" class="common-btn common-btn-round common-btn-black showHeart add-to-cart-ajax add_to_cart">Add to bag <span class="btn_price"><span class="price--on-sale"><span class="money">$' + review.reviewproductprice + '</span></span></span></button></form></div></div><div class="column-12 column-sm-7 column-md-8 column-lg-9"><div class="ProductReview__cntnt"><div class="d-flex justifyBetween ProductReview__starDate"><span class="stamped-starrating stamped-badge-starrating" aria-hidden="true"><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i><i class="stamped-fa stamped-fa-star" aria-hidden="true"></i></span><p>' + review.reviewDate + '</p></div><div class="Review__contentHolder"><h5 class="textUppercase">' + review.reviewTitle + '</h5><p>' + review.reviewMessage + '</p><h5 class="m-0 py-3 BuyerVerified">' + review.reviewauthor + '<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/verified.png?v=1632733611">Verified Buyer</span></h5></div><div class="d-flex justify-content-between Review__recomendHelp"> <div class="Review__recomended"><p><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/recommend.png?v=1632733611">Yes,<span>I recommend this product</span></p></div><div class="Review__helpful"><p>Was this review helpful?<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/thumsup.png?v=1632733611"></span>' + review.reviewVotesUp + '<span><img src="https://cdn.shopify.com/s/files/1/0053/4462/4675/files/greythumdown.png?v=1656067772"></span>' + review.reviewVotesDown + '</p></div></div><div class="d-flex-wrap ReviewProduct__images"> ' + mrgrimge + '</div></div></div></div></div>';
                    });
                    //alert(ajax_crevsg);
                    $('#' + responseid).html('');
                    $('#' + responseid).html(ajax_crevsg);
                },

                timeout: 5000000, // sets timeout to 5 seconds

            });
        });
        $(document).on('click', '.skrtparent', function() {
            $('.skrtparent').removeClass('active');
            $(this).addClass('active');
            child = $(this).attr('data-child');
            // alert(child);
            $('.skrtchild').addClass('hide');
            $('.skrtchild.' + child).removeClass('hide').find('button.fstchd').trigger("click");

        });
        $(document).on('click', '.sktpparent', function() {
            $('.sktpparent').removeClass('active');
            $(this).addClass('active');
            child = $(this).attr('data-child');
            // alert(child);
            $('.sktpchild').addClass('hide');
            $('.sktpchild.' + child).removeClass('hide').find('button.fstchd').trigger("click");

        });
        $(document).on('click', '.skprparent', function() {
            $('.skprparent').removeClass('active');
            $(this).addClass('active');
            child = $(this).attr('data-child');
            // alert(child);
            $('.skprchild').addClass('hide');
            $('.skprchild.' + child).removeClass('hide').find('button.fstchd').trigger("click");

        });
        $('.trulyTab li').click(function() {
            var tab_id = $(this).attr('data-tab');
            var tabval = $(this).html().toLowerCase().replace(/ /g, ''); //alert(tabval);
            $('.productsname' + tabval + ' li button').removeClass('active');
            $('.productsname' + tabval + ' li:first button').addClass('active');

            $('ul.trulyTab li').removeClass('current');
            $('.trulyTab__cntnt').removeClass('current');
            $(this).addClass('current');
            $("#" + tab_id).addClass('current');
            $("#" + tab_id + " .childstep ul").addClass('hide');
            var tabfstchild = $('.productsname' + tabval + ' li:first button').attr('data-child'); //alert(tabfstchild);
            $('.blemishpatchchilds').removeClass('hide');
            $('.breastchilds').removeClass('hide');
            $('.againgchilds').removeClass('hide');
            $("#" + tab_id).find('button.fstchd:first').addClass('active').trigger("click");
        });
    });
})(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-header"]) return;
  try {
    
(function($){ 
$(document).ready(function(){
console.log('header');
 let scrollheight
            if(window.matchMedia('(max-width: 750px)').matches) {
                scrollheight = 120
            }else{
                scrollheight = 100
                
            }
            
            let navhldr = $('.headerSection');
            let windowtop = scrollheight;
          
            
            // $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
            function navbarCheck() {
                if ($(window).scrollTop() >= windowtop) {
                      let navhldrHeight = navhldr.innerHeight()
                    navhldr.addClass('sticky');
                    $(".headerFixed__wrap").css("height" ,navhldrHeight+"px")
                    $(".recommendedFilter__Row").css("top" ,navhldrHeight+"px")
                } else {
                    navhldr.removeClass('sticky');
                    $(".headerFixed__wrap").css("height" ,"auto")
                    $(".recommendedFilter__Row").css("top" ,"auto")
                }
            }
            
            // navbarCheck()
            $(window).scroll(function () {
                navbarCheck()
            });  

            // navbarCheck()
            $(window).ready(function () {
                navbarCheck()
                //console.log("Hello World!");
            });   
            
            

            var new_scroll_position = 0;
            var last_scroll_position;
            var header = document.getElementById("header");

            window.addEventListener('scroll', function(e) {
                last_scroll_position = window.scrollY;

                if (new_scroll_position < last_scroll_position && last_scroll_position > scrollheight) {
                    header.classList.remove("slideDown");
                    header.classList.add("slideUp");
                    $("body").addClass("slideDownBody");
                    

                // Scrolling up
                } else if (new_scroll_position > last_scroll_position) {
                    header.classList.remove("slideUp");
                    header.classList.add("slideDown");
                    $("body").removeClass("slideDownBody");
                }

                new_scroll_position = last_scroll_position;
            });


  
  $(".smoothScroll").on('click', function(event) {
        
      if (this.hash !== "") {
        event.preventDefault();
        // Store hash
        var hash = this.hash;
        $('html, body').animate({ scrollTop: $(hash).offset().top}, 800, function(){ window.location.hash = hash;});
      } // End if

      
        if ($(window).width() < 1101) {
            $("html").removeClass("open--nav"), $(".freshNav__holder").slideUp(300);
            $(".freshNav__holder").removeClass("open--holder"); 
        } 

    });
  });
      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-with-products"] && !window.DesignMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
     $(".pdc--slider").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      mobileFirst: true,
      infinite: false,
      responsive: [
          { breakpoint: 575, lazyLoad: 'progressive', settings: "unslick", },
      ],
  });

         });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stickywraplanding"] && !window.DesignMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
      $(".sticky-wrap").addClass('sticky-show')
      //$(".head-order-btn").addClass('sticky-hide-head')
    } else {
      $(".sticky-wrap").removeClass('sticky-show')
     // $(".head-order-btn").removeClass('sticky-hide-head')
    }
});
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-sliderLeft"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 console.log('sliderLefht');                           
$('.onhalfSliderLeft').slick({
    slidesToShow: 2.5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: false,
    rtl: false,
    prevArrow: $(".onhalfSliderLeft__btn.onhalfSliderLeft__btnLeft"),
    nextArrow: $(".onhalfSliderLeft__btn.onhalfSliderLeft__btnRight"),

    responsive: [{
        breakpoint: 990,
        settings: {
            slidesToShow: 1.5,
        }
    }]
      });
});
 })(jQuery);     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["TextSlider"] && !window.DesignMode) return;
  try {
    
  (function($){
    $(document).ready(function(){
      $('.featureSlider').slick({
        speed: 8000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        pauseOnHover: false,
        pauseOnFocus: false,
    });

  $('.featureSlider2').slick({
        speed: 25000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        pauseOnHover: false,
        pauseOnFocus: false,
    });

      
    });
 
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-grtid-section"] && !window.DesignMode) return;
  try {
    
  (function($){
 $(document).ready(function () {
  $(".skincare--slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    mobileFirst: true,
    infinite: false,
    responsive: [
        { breakpoint: 750, lazyLoad: 'progressive', settings: "unslick", },
    ],
});

       });
})(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-challenge-banner"] && !window.DesignMode) return;
  try {
    

  
(function($){ 
  console.log('333333333ewew');
    function run_animate() {
         var ml3 = 0;
        setInterval(function() {
            if (ml3 <= 0 - $(".barbie__animate .barbie__animateWrap").width() / 2) {
            ml3 = 0;
            }
        $(".barbie__animate .barbie__animateWrap").css("margin-left", ml3);
            ml3 -= 1;
        }, 10);
        }
      run_animate();    
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-video-text"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
             $(".mobileVideoSlider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            swipeToSlide: true,
            infinite: true,
            centerMode: true,
            centerPadding: "80px",
            mobileFirst: true,
            responsive: [
                { breakpoint: 750, lazyLoad: 'progressive', settings: "unslick", },
                { breakpoint: 749, settings: { slidesToShow: 1, slidesToScroll: 1, useTransform: false} },
            ],
        });
  
       $(".boxVideo__btn").click(function () {
          var video = $(this).parents('.boxVideo').find(".boxVideo__video").get(0);
      
          video.addEventListener('ended', myHandler, false);
          
          $(this).toggleClass("active");
          if (video.paused === true) {
              video.play();
          } else {
              video.pause();
          }
      
          function myHandler(e) {
              $(this).parents(".famousTiktok__box").find(".boxVideo__btn").removeClass("active");        
          }
      });


        $('.mobileVideoSlider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('video').each(function () {
                this.pause(); // Stop playing
            });
        });

        });
      })(jQuery);     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktokChallenge-video"] && !window.DesignMode) return;
  try {
    
(function($){ 
  console.log('slider1rrggqqd');
$(document).ready(function(){
 $(".tiktokVideoSlider").slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true,
            // swipeToSlide: true,
            infinite: true,
            // centerMode: true,
            // centerPadding: "0",
            // mobileFirst: true,
            responsive: [
                // { breakpoint: 750, lazyLoad: 'progressive', settings: "unslick", },
                { breakpoint: 751, settings: { slidesToShow: 2, slidesToScroll: 2, } },
                { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1,  dots: false,  arrows: true, } },
            ],
        });
 $('.tiktokVideoSlider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('video').each(function () {
                this.pause(); // Stop playing
            });
        }); 
});
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-giveaways-form"] && !window.DesignMode) return;
  try {
    
      $(document).ready(function() {
          // Initialize intl-tel-input
          const phoneInputField = document.querySelector("#phone_number");
          const phoneInput = window.intlTelInput(phoneInputField, {
              initialCountry: "us",
              strictMode: true,
              utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
          });

  var input = document.querySelectorAll('#signup_birthday')[0];

  var dateInputMask = function dateInputMask(elm) {
    elm.addEventListener('keypress', function(e) {
      if(e.keyCode < 47 || e.keyCode > 57) {
        e.preventDefault();
      }
      var len = elm.value.length;
      if(len !== 1 || len !== 3) {
        if(e.keyCode == 47) {
          e.preventDefault();
        }
      }

      if(len === 2) {
       var month = elm.value.substring(0, 2);
          if (parseInt(month, 10) > 12) {
              month = '12'; // Max month is 12
          }
      elm.value = month;
      elm.value += '-';
      }

      if(len === 5) {
        var day = elm.value.substring(3, 5);
          if (parseInt(day, 10) > 31) {
              day = elm.value.substring(0, 3)+'31'; // Max day is 31
          }else{
            day = elm.value.substring(0, 3)+day;
          }
        elm.value = day;
        elm.value += '-';
      }
    });
  };

  dateInputMask(input);

              // form validations and form data
              const emptyError = "Please fill out this field.";
              const $submitButton = $("#submit_detail"); // Store the submit button
              const formAction = $("#register_form").attr("action");
              console.log(formAction);
              $("form#register_form").on('submit', function(e) {
                  e.preventDefault(); // Prevent default form submission
                  let isValid = true;
                  let firstInvalidField = null;
                  // List of required fields
                  const required = [
                      'first_name', 'last_name', 'email', 'phone_number',
                      'signup_birthday , smscheckbox'
                  ];

                  // Clear previous error messages and styling
                  $("input").removeClass("needsfilled_giveaway error");
                  $(".error-message").text('');

                  // Validate required fields
                  for (const field of required) {
                      const input = $('#' + field);
                      if (input.val() === "" || input.val() === emptyError) {
                          input.addClass("needsfilled_giveaway error");
                          isValid = false;
                          if (!firstInvalidField) firstInvalidField = input;
                      } else {
                          input.removeClass("needsfilled_giveaway");
                      }
                  }

                  // Additional validation for email address
                  const email = $("#company_email");
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailRegex.test(email.val()) || email.val() === "" && email.hasClass('needsfilled_giveaway')) {
                      email.addClass("needsfilled_giveaway error");
                      email.val("Enter valid email address"); // Set the placeholder text
                      isValid = false;
                      if (!firstInvalidField) firstInvalidField = email;
                  }

                  // Additional validation for phone number
                  let PhoneNumber = $('#phone_number');
                  if (!phoneInput.isValidNumber() || PhoneNumber.val() === "" && PhoneNumber.hasClass('needsfilled_giveaway')) {
                      $('#phone_number').addClass("needsfilled_giveaway error");
                      PhoneNumber.val("Enter valid phone number"); // Set the placeholder text
                      isValid = false;
                      if (!firstInvalidField) firstInvalidField = $('#phone_number');
                  }

                  // checkbox validation
                   const smsCheckbox = $("#smscheckbox");
                    if (!smsCheckbox.is(":checked")) {
                        $("#smscheckbox").addClass('redcheckbox')
                        smsCheckbox.focus();
                        isValid = false;
                        return false; // Prevent form submission
                    }else{
                      $("#smscheckbox").removeClass('redcheckbox')
                    }
                  // If all fields are valid, change button text to "Submitting..." and disable it
                  if (isValid) {
                      $submitButton.text("Submitting...").prop("disabled", true);

                      let formDataArray = $(this).serializeArray();

                      // Remove the company_postal_code field and any blank fields from formDataArray
                      formDataArray = formDataArray.filter(function(field) {
                          return field.value.trim() !== "";
                      });

                      // Add the formatted phone number to formDataArray
                      const formattedPhoneNumber = phoneInput.getNumber();
                      formDataArray.push({
                          name: 'phone_number',
                          value: formattedPhoneNumber
                      });

                      // Convert formDataArray back to object
                      const formData = {};
                      formDataArray.forEach(function(item) {
                          formData[item.name] = item.value;
                      });
                      console.log(formData);
                      $.ajax({
                          type: 'POST',
                          url: formAction,
                          data: formData,
                          success: function(response) {
                              if (typeof response === "string") {
                                  response = JSON.parse(response);
                              }
                              console.log("Raw response:", response);
                              if (response.status === 'success') {
                               $('.success-message').html(`<span class="response-style"> ${response.message} </span>` )
                               $('#first_name').val("");
                               $('#last_name').val("");
                               $('#company_email').val("");
                               $('#phone_number').val("");
                               $('#signup_birthday').val(""); 
                              }else{
                               $('.success-message').html(`<span class="response-style redresponse"> ${response.message} </span>`) 
                              }
                              setTimeout(function () {
                                  $('.response-style, .redresponse').fadeOut(100, function () {
                                      $(this).remove();
                                  });
                              }, 3000);
                              $submitButton.text("Submit").prop("disabled", false);
                          },
                          error: function(xhr, status, error) {
                              console.error('An error occurred. Please try again.', error);
                              $('.error-message').html('<span class="response-style"> An error occurred. Please try again.</span>');
                              $submitButton.text("Submit").prop("disabled", false); // Re-enable the button on error
                          }
                      });
                  } else {
                      if (firstInvalidField) {
                          $('html, body').animate({
                              scrollTop: firstInvalidField.offset().top
                          }, 500, function() {
                              firstInvalidField.focus();
                          });
                      }
                      console.log('Please fill out all required fields.');
                      $submitButton.text("Submit").prop("disabled", false); // Re-enable the button on validation error
                  }
              });
              $(":input").focus(function() {
                  if ($(this).hasClass("needsfilled_giveaway")) {
                      $(this).val("");
                      $(this).removeClass("needsfilled_giveaway error");
                  }
              });

      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-order"] && !window.DesignMode) return;
  try {
    
(function($){ 
//console.log('trulyorderpages');
$(document).ready(function(){
$('.priceBox').hide();

        setTimeout(function(){
          $('.priceBox').fadeIn('slow');
        },500);
  $('.selectOption__Style').each(function () {
          var $this = $(this), numberOfOptions = $(this).children('option').length;
  
          $this.addClass('select-hidden');
          $this.wrap('<div class="select"></div>');
          $this.after('<div class="select-styled"></div>');

          var $styledSelect = $this.next('div.select-styled');
          $styledSelect.text($this.children('option').eq(0).text());

          var $list = $('<ul />', {
            'class': 'select-options',
            'id':'parent_selectul'
          }).insertAfter($styledSelect);

          for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
              text: $this.children('option').eq(i).text(),
              rel: $this.children('option').eq(i).val(),

            }).appendTo($list);
            //if ($this.children('option').eq(i).is(':selected')){
            //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
            //}
          }

          var $listItems = $list.children('li');

          $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
              $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
          });

          $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            //console.log($this.val());
          });

          $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
          });

        });
   
 $(' .select-options li').click(function() {
            $('input[name="sellingplan_option"]').prop('checked', false);
            $(".btn-radi1o").prop("checked", true);
            var radioValue = $('input[type=radio][name=sellingplan_option]:checked').val();
            if (radioValue == 'onetime') {
                $('.selling_plan').attr("name", "").css('display', 'none');
            }
        });
  
       var optionValue_firstboxdefault = $(".bydefault_box1").val();
      //console.log('optionValue_firstboxdefault:',optionValue_firstboxdefault);
        var optionValue_secondboxdefault = $(".bydefault_box2").val();
        var optionValue_thirdboxboxdefault = $(".bydefault_box3").val();
        var optionValue_fourboxboxdefault = $(".bydefault_box4").val();
        var optionValue_fifthboxboxdefault = $(".bydefault_box5").val();
        var optionValue_sixthboxboxdefault = $(".bydefault_box6").val();
        $("." + optionValue_secondboxdefault).show();
        $("." + optionValue_firstboxdefault).show();
        $("." + optionValue_thirdboxboxdefault).show();
        $("." + optionValue_fourboxboxdefault).show();
        $("." + optionValue_fifthboxboxdefault).show();
        $("." + optionValue_sixthboxboxdefault).show();
 

        $('.priceEach, .product__SubTitle, .Sub_priceEach ').css("display", "none");
        $('.priceEach:first-child').css("display", "flex");

        $("#parent_selectul li").click(function() {
//alert('g');
            $('.suscribe__productGrid').removeClass('selected_grid');

            var optionValue = $(this).attr('rel');
            // alert(optionValue);
            $(this).closest('.suscribe__productGrid').addClass('selected_grid');


            $(this).find('li').removeClass('selectedLi');
            $(this).addClass('selectedLi');
            if (optionValue) {

                $(".selected_grid .box, .selected_grid .priceEach ").not(".selected_grid ." + optionValue).hide();
                var count = ($('.box[data-id*=' + optionValue + ']').length);
                $(".selected_grid ." + optionValue).show();
                $(".selected_grid .priceEach ." + optionValue).css("display", "flex");
            //    $('.selected_grid .flexAuto .box').children('span').text(count);
                $(".selected_grid .default").hide();
            } else {
                $(".selected_grid .box, .selected_grid .priceEach ").hide();
                $(".selected_grid .default").show();
            }

        });  


        });
      })(jQuery);  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-sms-subscribe"] && !window.DesignMode) return;
  try {
    
  (function($){
       $(document).ready(function(){  
           $("#ps__phone-subscribe").keypress(function (e) {
          if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
          }
          var curchr = this.value.length;
          var curval = $(this).val();
          if (curchr == 3 && curval.indexOf("(") <= -1) {
            $(this).val("(" + curval + ")" + "-");
          } else if (curchr == 4 && curval.indexOf("(") > -1) {
            $(this).val(curval + ")-");
          } else if (curchr == 5 && curval.indexOf(")") > -1) {
            $(this).val(curval + "-");
          } else if (curchr == 9) {
            $(this).val(curval + "-");
            $(this).attr('maxlength', '15');
          }
        });
      });
    })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-subscription-box"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function(){
 //console.log('smo');
  $(".subscribe-info .common-btn").click(function() {
        $('html,body').animate({
            scrollTop: $(".choose-subscribe-sec").offset().top},
            'slow');
    });
  
    $(".smoothScroll").on('click', function(event) {

                if (this.hash !== "") {
                    event.preventDefault();
                    // Store hash
                    var hash = this.hash;
                    $('html, body').animate({ scrollTop: $(hash).offset().top}, 800, function(){ window.location.hash = hash;});
                } // End if
                });


$(".sub_Mob-One").slick({
    slidesToShow: 1.25,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    dots: false,
    mobileFirst: true,
    infinite: false,
    responsive: [
        { breakpoint: 989, lazyLoad: 'progressive', settings: "unslick", },
        // {breakpoint: 989, settings: {slidesToShow: 1, slidesToScroll: 1, dots: false, arrows: true,}},
    ],
});


// $(window).resize(function () {
//     if ($(window).width() < 990) {
//         $('.sub_Mob-One').slick({});
//     } else {
//         $('.sub_Mob-One').slick('unslick');
//     }
// });       

        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truly-subscription-gallery"] && !window.DesignMode) return;
  try {
    
(function($){ 
$(document).ready(function() {
//console.log('gallery');
$.fn.randomize = function(selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function() {
        $(this).children(selector).sort(function(childA, childB) {
            // * Prevent last slide from being reordered
            if ($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
            }
        }.bind(this)).detach().appendTo(this);
    });

    return this;
};
$('.subscribeGallerySlider').find('.subscribe-gallery').randomize('.gallery-img');

$(".subscribeGallerySlider").randomize().slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
})
});
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trulyraffle"] && !window.DesignMode) return;
  try {
    
  (function($){
   $(document).ready(function () {
          const phoneInputField = document.querySelector("#phone_number");
    const phoneInput = window.intlTelInput(phoneInputField, {
     utilsScript:
       "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
   });
          const phoneNumber = phoneInput.getNumber();

          errornotice = $("#error");
          successnotice = $("#success");
          emptyerror = "Please fill out this field.";
          emailerror = "Please enter a valid e-mail.";

          $("form#kiayvio_request").submit(function(){
            required = ["phone_number","instagram_username","name"];
            email = $("#email");
            for (i=0;i<required.length;i++) {
              var input = $('#'+required[i]);
              if ((input.val() == "") || (input.val() == emptyerror)) {
                input.addClass("needsfilled");
                input.val(emptyerror);
                errornotice.fadeIn(750);
              } else {
                input.removeClass("needsfilled");
              }
            }
            if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val(emailerror);}
            if ($('#special_offer').is(':checked')){$('#special_offer_label').css("color","#000");}

            phonenumber = phoneInput.getNumber();
            if ($(":input").hasClass("needsfilled")) {
              return false;
            }else if (! $('#special_offer')[0].checked){
              $('#special_offer_label').css("color","#ff0000");
              return false;
            }else if(phonenumber.indexOf('+') == -1){
              $('#phone_number').addClass("needsfilled");
              return false;
            } else {
              var $form = $('#kiayvio_request');
              var formData = new FormData($($form.get(0))[0]);
              formData.append('phone_number', phonenumber);
              $(document).ajaxStart(function(){
                $('#submit_detail').attr("disabled", "disabled");
              }).ajaxStop(function(){
                $('#submit_detail').removeAttr("disabled");
              });
              $.ajax({
                url: "https://mytrulydeals.com/trulybeauty/klayvio-form.php",
                type: 'POST',
                data: formData,
                async: true,
                success: function (data) {
                  $form.find('#submit_detail').prop('disabled', false);

                  if (data.indexOf('Thank you') > -1) {
                    $('form#kiayvio_request').get(0).reset();
                    $('.raffle-response').html('<p>Thank you for entering the Truly Beauty Raffle. Good luck!</p>').css("color","#509d24");
                    $('.raffle-response p').css("color","#509d24");
                    setTimeout(function() { $(".raffle-response").html(''); }, 5000)
                  }else{
                    $('.raffle-response').html('<p>'+data+'</p>').css("color","#ff0000");
                    $('.raffle-response p').css("color","#ff0000");
    setTimeout(function() { $(".raffle-response").html(''); }, 5000)
                  }

                },
                timeout: 5000000, // sets timeout to 5 seconds
                contentType: false,
                processData: false
              });
              return false;
            }
          });

          $(":input").focus(function(){if ($(this).hasClass("needsfilled") ) {$(this).val("");$(this).removeClass("needsfilled");}});


        });


      })(jQuery);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valentines-day"] && !window.DesignMode) return;
  try {
    
   (function($){
   $(document).ready(function(){
  $(".customerFavourite").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: !1,
            dots: false,
            fade: false,
            infinite: false,
            // prevArrow: $(".favPrev__btn"),
            // nextArrow: $(".favNext__btn"),
            responsive: [{
                breakpoint: 990,
                settings: { slidesToShow: 3 }
            }, {
                breakpoint: 751,
                settings: { slidesToShow: 2 }
            },]
        });
        });
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanilla-viplist-form"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
    // Initialize intl-tel-input
    const phoneInputField = document.querySelector("#phone_number");
    const phoneInput = window.intlTelInput(phoneInputField, {
        initialCountry: "us",
        strictMode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js"
    });

    $('#register_form').on('submit', function (e) {
        e.preventDefault(); // Prevent the default form submission
        
        const fname = $('#first_name');
        const email = $('#email');
        const phone = $('#phone_number');
        var actionValue = $("#register_form").attr("action");
        let isValid = true;

        // Validate first name
        if (fname.val().trim() === '') {
            fname.addClass("form_error");
            fname.attr("placeholder", "Enter full name");
            isValid = false;
        } else {
            fname.removeClass("form_error");
        }

        // Validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.val().trim())) {
            email.addClass("form_error");
            email.val("").attr("placeholder", "Enter a valid email address");
            isValid = false;
        } else {
            email.removeClass("form_error");
        }

        // Validate phone
        if (phoneInput.getNumber().trim() === "" || !phoneInput.isValidNumber()) {
            phone.addClass("form_error");
            phone.val("").attr("placeholder", "Enter a valid phone number");
            isValid = false;
        } else {
            phone.removeClass("form_error"); 
        }
        // Validate marting and sms
        if ($('input#marktingsmsemail').is(':checked')) {
            $('input#marktingsmsemail').removeClass("form_error");
        } else {
           $('input#marktingsmsemail').addClass("form_error");
            isValid = false;
        }

        // Submit form if all fields are valid
        if (isValid) {
            const formData = {
                ajaxaction: 'limitededitionvbb',
                first_name: fname.val().trim(),
                email: email.val().trim(),
                phone_number: phoneInput.getNumber()
            };
            $.ajax({
            url: actionValue,
            type: 'POST',
            data: formData,
            success: function (response) {
                    if (typeof response === "string") {
                        response = JSON.parse(response);
                    }
                    if (response.status === 'success') {
                        $('#button_response').after(
                            `<p class='response_text'>${response.message}</p>`
                        );
                    } else {
                        $('#button_response').after(
                            `<p class='response_text_red'>${response.message}</p>`
                        );
                    }
                   setTimeout(function () {
                    $('.response_text, .response_text_red').fadeOut(100, function () {
                        $(this).remove();
                    });
                }, 3000);
            },
            error: function (xhr, status, error) {
                console.error('Error:', error);
                $('#button_response').after(
                    `<p class='response_text_red'>Form is not submitted due to ${error}</p>`
                );
        
                // Automatically remove error message after 3 seconds
                setTimeout(function () {
                    $('.response_text_red').fadeOut(100, function () {
                        $(this).remove();
                    });
                }, 3000);
            }
        });
        }
    });  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-product-main"] && !window.DesignMode) return;
  try {
    
 
(function($){    

   $(document).ready(function() {
     $('.product-form__variants').on('change', function() {
      var selectedValue = $(this).val();
    $('.subscription_product').val(selectedValue);
     $('.subscription_var_price').addClass('var_change');
  });
});
  
  function productvariation_switch(){
     
          var variationID = $('.product-form__variants option:selected').val();
          var productUrl = $('.productDetail input[name="producthandle"]').val();
          var onetimesubscribeoption = $('input[type=radio][name=sellingplan_option]:checked').val();
          jQuery.getJSON(productUrl + '.js', function(product) {
            $.each(product.variants, function(i){
              if( product.variants[i].id == variationID ){
                var price = product.variants[i].price;
            var compare_price = product.variants[i].compare_at_price;
                if(product.variants[i].featured_media!=null){
                  var variantimageID = product.variants[i].featured_media.id;

             
                }
            if(typeof onetimesubscribeoption !== "undefined" && onetimesubscribeoption=='subscription'){ //
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                   $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                   $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                    $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  var sellingplan = $('select[name="selling_plan"]').val();
                  $.each(product.variants[i].selling_plan_allocations, function(j){
                    if(sellingplan==product.variants[i].selling_plan_allocations[j].selling_plan_id){
                      var price = product.variants[i].selling_plan_allocations[j].price;
                      $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                    }
                  });
                }else{
                if(product.variants[i].selling_plan_allocations!=''){
                  var subscribeprice = product.variants[i].selling_plan_allocations[0].price_adjustments[0].price;
                  $('.onetime_purchase .moneyprice > .money').html(theme.Currency.formatMoney(price, theme.moneyFormat));
                  $('.onetime_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat));
                  $('.subscription_purchase .moneyprice > .compare-pp').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                        $('.subscription_var_price.var_change .selingplan_money > .money').html(theme.Currency.formatMoney(subscribeprice, theme.moneyFormat)); 
                     $('.subscription_var_price.var_change .price__sale > .money').html(theme.Currency.formatMoney(compare_price, theme.moneyFormat));
                }
                  $('.product-form__variants').closest( "form" ).find('.productprice > span.money').html(theme.Currency.formatMoney(price, theme.moneyFormat));

                }
                if(variantimageID){
                  $('.productSliderNav img').each(function(){
                    if ($(this).attr("id") == variantimageID) {
                      $(this).click();
                      $(this).parent().parent().addClass('slick-current');
                    }
                  });
                }
    // console.log("price:",price);
    // document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", price);
    // window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    // window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
              }
            })

          });
        }
$(document).ready(function(){  
productvariation_switch();
$('.product-form__variants').on('change', function() {
productvariation_switch();
});
  
// $(window).on('scroll', function () {
//     if ($(window).scrollTop() >= $('.stickyWrapShow').offset().top ) {
//       $(".sticky-wrap").addClass('sticky-show')
//       //$(".head-order-btn").addClass('sticky-hide-head')
//     } else {
//       $(".sticky-wrap").removeClass('sticky-show')
//      // $(".head-order-btn").removeClass('sticky-hide-head')
//     }
// });
  

});
      })(jQuery);    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbc-ordinary-vanilla"] && !window.DesignMode) return;
  try {
    
  (function($){
    $(document).ready(function(){
            $(".ordinary_slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            dots: true,
            centerMode: true,
            centerPadding: '25%',
            responsive: [
                { breakpoint: 750, settings: { centerPadding: '15%', } },
            ]
        });
        $('.ordinary_slider').on('afterChange', function (event, slick, currentSlide) {
            console.log(event)
            let html = $(event.target).find(".slick-current .ordinary_text");
            if (html.length) {
                $(".ordinary_product_info").html($(html[0]).clone());
            }
        });
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbc-vanilla-video"] && !window.DesignMode) return;
  try {
    

  $(document).ready(function () {
    var video = $(".PlayVideoBox video");
    var playPauseBtn = $("#videoplayBtn");
    var playIcon = playPauseBtn.find(".playBtn");
    var pauseIcon = playPauseBtn.find(".pausebtn");

    playPauseBtn.on("click", function () {
        if (video.get(0).paused) {
            video.get(0).play();
            playPauseBtn.removeClass("active");
            playIcon.css("opacity", "0");
            pauseIcon.css("opacity", "1");
        } else {
            video.get(0).pause();
            playPauseBtn.addClass("active");
            playIcon.css("opacity", "1");
            pauseIcon.css("opacity", "0");
        }
    });

    // Ensure correct button state on video load
    video.on("play", function () {
        playPauseBtn.removeClass("active");
        playIcon.css("opacity", "0");
        pauseIcon.css("opacity", "1");
    });

    video.on("pause", function () {
        playPauseBtn.addClass("active");
        playIcon.css("opacity", "1");
        pauseIcon.css("opacity", "0");
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !window.DesignMode) return;
  try {
    
(function($){
 $(document).ready(function () {
    console.log('xxxssss');
   $(".video--slider").slick({
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay: false,
    arrows: false,
    dots: true,
    // adaptiveHeight: true,
    // mobileFirst: true,
    infinite: true,
    responsive: [
        { breakpoint: 1421, settings: { slidesToShow: 4, slidesToScroll: 2, } },
        { breakpoint: 1101, settings: { slidesToShow: 3, slidesToScroll: 2, } },
        { breakpoint: 990, settings: { slidesToShow: 2, slidesToScroll: 2, } },
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1, } },
    ],
});
   });
    })(jQuery);  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viptabslider"] && !window.DesignMode) return;
  try {
    
  (function($){ 
$(document).ready(function(){
   var vip__MainSlider = {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      dots: false,
      infinite: false,
      prevArrow: $(".favPrev__btn"),
      nextArrow: $(".favNext__btn"),
      responsive: [
          { breakpoint: 1101, settings: { slidesToShow: 3 } },
          { breakpoint: 751, settings: { slidesToShow: 2 } },
        //   { breakpoint: 500, settings: { slidesToShow: 2 } },
          ],
    }

      $(".vip__TabSlider").slick(vip__MainSlider);

        $(".benefit_toggle").click(function () {
            $(this).parent().toggleClass("benefit_show");
        });
   });
})(jQuery);   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["webquiz"] && !window.DesignMode) return;
  try {
    
 
(function($){    

   $(document).ready(function() {
      console.log('rrs');
});
  })(jQuery);    

  } catch(e) { console.error(e); }
})();
})();
